{
  "common": {
    "loading": "جارٍ التحميل…",
    "retry": "إعادة المحاولة",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "back": "رجوع",
    "logout": "تسجيل الخروج",
    "or": "أو",
    "home": "الرئيسية",
    "poweredBy": "بدعم من {{product}}",
    "academicYear": "السنة الجامعية {{year}}",
    "save": "حفظ",
    "edit": "تعديل",
    "delete": "حذف",
    "all": "الكل",
    "reset": "إعادة التعيين",
    "columns": "الأعمدة",
    "export": "تصدير",
    "actions": "إجراءات",
    "saving": "جارٍ الحفظ…",
    "saved": "تمّ الحفظ",
    "phaseSoon": "متوفر في المرحلة {{phase}}"
  },
  "languages": {
    "fr": "Français",
    "ar": "العربية",
    "en": "English",
    "short": {
      "fr": "FR",
      "ar": "العربية",
      "en": "EN"
    }
  },
  "roles": {
    "SUPER_ADMIN": "المشرف العام على المنصة",
    "ADMIN_ECOLE": "الإدارة",
    "AGENT_SCOLARITE": "عون الشؤون الدراسية",
    "AGENT_FINANCE": "عون المالية",
    "ENSEIGNANT": "أستاذ",
    "ETUDIANT": "طالب",
    "CANDIDAT": "مترشح"
  },
  "auth": {
    "heroTitle": "فضاؤك للشؤون الدراسية",
    "heroText": "الترسيمات والأعداد والغيابات والخلاص والوثائق الرسمية — في مكان واحد، لكامل الفريق ولكل طالب.",
    "title": "تسجيل الدخول",
    "subtitle": "استعمل بريدك الإلكتروني المؤسساتي أو المعرّف الجامعي.",
    "identifier": "البريد الإلكتروني أو المعرّف",
    "password": "كلمة المرور",
    "showPassword": "إظهار كلمة المرور",
    "hidePassword": "إخفاء كلمة المرور",
    "remember": "البقاء متصلًا",
    "forgot": "نسيت كلمة المرور؟",
    "submit": "دخول",
    "submitting": "جارٍ الدخول…",
    "sso": "المتابعة عبر الدخول الموحّد (SSO)",
    "ssoShort": "الدخول الموحّد",
    "ssoInfo": "سيتوفر الدخول الموحّد عندما تقوم مؤسستك بإعداده.",
    "newCandidate": "مترشح جديد؟",
    "applyLink": "إيداع تسجيل مسبق",
    "footer": "© {{year}} {{institution}}",
    "privacy": "الخصوصية",
    "help": "مساعدة",
    "forgotSent": "إذا كان هناك حساب يطابق « {{identifier}} »، فقد تمّ إرسال رابط إعادة التعيين.",
    "forgotNeedIdentifier": "أدخل أولًا بريدك الإلكتروني أو المعرّف.",
    "errors": {
      "identifierRequired": "أدخل بريدك الإلكتروني أو المعرّف.",
      "passwordRequired": "أدخل كلمة المرور.",
      "invalidCredentials": "البريد الإلكتروني أو المعرّف أو كلمة المرور غير صحيحة.",
      "locked": "محاولات كثيرة: حسابك مقفل لمدة 15 دقيقة.",
      "rateLimited": "محاولات كثيرة. أعد المحاولة بعد دقيقة.",
      "generic": "تعذّر الدخول. تحقّق من الشبكة ثم أعد المحاولة.",
      "passwordTooShort": "يجب أن تتكوّن كلمة المرور من {{min}} أحرف على الأقل.",
      "passwordMismatch": "كلمتا المرور غير متطابقتين.",
      "passwordUnchanged": "يجب أن تختلف كلمة المرور الجديدة عن الحالية."
    },
    "reset": {
      "title": "كلمة مرور جديدة",
      "subtitle": "اختر كلمة مرور من {{min}} أحرف على الأقل.",
      "password": "كلمة المرور الجديدة",
      "confirm": "تأكيد كلمة المرور",
      "submit": "حفظ كلمة المرور",
      "submitting": "جارٍ الحفظ…",
      "done": "تمّ تغيير كلمة المرور. يمكنك الآن تسجيل الدخول.",
      "invalid": "هذا الرابط غير صالح أو منتهي الصلاحية. قدّم طلبًا جديدًا من صفحة الدخول.",
      "backToLogin": "العودة إلى تسجيل الدخول"
    },
    "identifierPlaceholder": "مثال: 24GL0137 أو البريد الإلكتروني",
    "features": {
      "notes": "الأعداد والمداولات وكشوف أمد",
      "absences": "المناداة عبر الجوال ومتابعة الغيابات",
      "finance": "جداول الخلاص والدفوعات والوصولات",
      "documents": "وثائق رسمية قابلة للتحقق برمز QR"
    },
    "forgotTitle": "نسيت كلمة المرور",
    "forgotText": "أدخل بريدك الإلكتروني أو رقم تسجيلك: إن وُجد حساب مطابق، ستصلك رسالة برابط لاختيار كلمة مرور جديدة.",
    "forgotSubmit": "إرسال الرابط",
    "platform": {
      "heroTitle": "وحدة تحكّم المنصّة",
      "heroText": "أنشئ المؤسسات وادعُ مسؤوليها وتحكّم في نفاذها. تبقى بيانات كل مؤسسة في فضائها الخاص.",
      "features": {
        "schools": "المؤسسات وعناوينها الخاصة",
        "invites": "دعوة المسؤولين",
        "suspend": "التعليق وإعادة التفعيل",
        "restricted": "نفاذ مخصّص لفريق المنصّة"
      },
      "subtitle": "نفاذ مخصّص لفريق المنصّة. سجّل الدخول ببريدك الإلكتروني.",
      "identifier": "البريد الإلكتروني",
      "identifierPlaceholder": "name@…"
    }
  },
  "shell": {
    "menu": "القائمة",
    "productLine": "{{product}} · {{space}}",
    "search": "ابحث عن طالب، رقم بطاقة التعريف أو المعرّف…",
    "searchShortcut": "Ctrl K",
    "lightTheme": "المظهر الفاتح",
    "darkTheme": "المظهر الداكن",
    "notifications": "الإشعارات",
    "notificationsCount_zero": "لا توجد إشعارات غير مقروءة",
    "notificationsCount_one": "إشعار واحد غير مقروء",
    "notificationsCount_two": "إشعاران غير مقروءين",
    "notificationsCount_few": "{{count}} إشعارات غير مقروءة",
    "notificationsCount_many": "{{count}} إشعارًا غير مقروء",
    "notificationsCount_other": "{{count}} إشعار غير مقروء",
    "noNotifications": "لا توجد إشعارات.",
    "markAllRead": "تعليم الكل كمقروء",
    "language": "اللغة",
    "year": "السنة الجامعية",
    "account": "الحساب",
    "skipToContent": "الانتقال إلى المحتوى",
    "space": {
      "scolarite": "الشؤون الدراسية",
      "finance": "المالية",
      "teaching": "فضاء المدرّس"
    }
  },
  "yearStatus": {
    "draft": "مسودة",
    "current": "جارية",
    "closed": "مغلقة",
    "archived": "مؤرشفة"
  },
  "nav": {
    "groups": {
      "pilotage": "القيادة",
      "admissions": "القبول",
      "scolarite": "الدراسة",
      "evaluation": "التقييم",
      "finance": "المالية",
      "administration": "الإدارة"
    },
    "items": {
      "dashboard": "لوحة القيادة",
      "preinscriptions": "التسجيل المسبق",
      "candidatures": "الترشحات",
      "students": "الطلبة",
      "teachers": "الأساتذة",
      "curriculum": "عرض التكوين",
      "timetable": "جدول الأوقات",
      "absences": "الغيابات",
      "grades": "إدخال الأعداد",
      "rollCall": "المناداة",
      "deliberations": "المداولات",
      "documents": "كشوف الأعداد والشهادات",
      "schedules": "الأقساط",
      "unpaid": "غير المسدّد",
      "settings": "الإعدادات",
      "announcements": "الإعلانات",
      "audit": "سجلّ التدقيق",
      "calendar": "الرزنامة",
      "internships": "التربصات ومشاريع التخرج"
    }
  },
  "palette": {
    "label": "البحث الشامل",
    "placeholder": "الاسم، رقم بطاقة التعريف، المعرّف أو صفحة…",
    "escape": "Esc",
    "students": "الطلبة",
    "pages": "الصفحات",
    "noStudent": "لا يوجد طالب يطابق « {{q}} ».",
    "meta": "{{matricule}} · ب.ت.و {{cin}}",
    "level": "{{level}} · الفوج {{group}}"
  },
  "comingSoon": {
    "title": "الوحدة قيد الإعداد",
    "text": "سيتمّ تسليم هذه الشاشة في المرحلة {{phase}}. التنقل وصلاحيات النفاذ والبحث تعمل منذ الآن."
  },
  "dashboard": {
    "greeting": "مرحبًا {{name}} — {{date}}.",
    "greetingWeek": "مرحبًا {{name}} — نشاط يوم {{date}}، الأسبوع {{week}}.",
    "newEnrollment": "ترسيم جديد",
    "kpi": {
      "students": "الطلبة المرسّمون",
      "vsPrevious": "مقارنة بالسنة الماضية",
      "applications": "الترشحات في الانتظار",
      "staleNote": "دون ردّ منذ أكثر من {{days}} أيام",
      "paymentRate": "نسبة الخلاص",
      "ofDue": "من {{amount}} مستحقة",
      "absences": "غيابات الأسبوع",
      "nearNote": "قريبون من عتبة الإقصاء",
      "nearCount_zero": "لا طالب",
      "nearCount_one": "طالب واحد",
      "nearCount_two": "طالبان",
      "nearCount_few": "{{count}} طلبة",
      "nearCount_many": "{{count}} طالبًا",
      "nearCount_other": "{{count}} طالب"
    },
    "programs": {
      "title": "الترسيمات حسب المسلك",
      "subtitle": {
        "all": "المسجّلون / طاقة الشعبة (كل السنوات) · {{year}}",
        "first": "المسجّلون في السنة الأولى / مقاعد الانتداب · {{year}}",
        "upper": "المسجّلون من السنة الثانية فما فوق / المقاعد المتبقية · {{year}}"
      },
      "first": "السنة الأولى",
      "upper": "السنة الثانية فما فوق",
      "fill": "نسبة الامتلاء:",
      "total": "مجموع المرسّمين:"
    },
    "todo": {
      "title": "للمعالجة",
      "juries": {
        "title": "مداولات يجب عقدها",
        "meta": "لجان الدورة الرئيسية غير المختومة",
        "action": "فتح"
      },
      "incompleteApplications": {
        "title": "ملفات ترشح منقوصة",
        "meta": "وثائق إجبارية ناقصة أو مرفوضة",
        "action": "عرض"
      },
      "staleApplications": {
        "title": "ترشحات دون ردّ",
        "meta": "تجاوزت الأجل المعلن للمترشحين",
        "action": "دراسة"
      },
      "pendingCheques": {
        "title": "صكوك للاستخلاص",
        "meta": "دفوعات بالصك في الانتظار",
        "action": "معالجة"
      },
      "count_zero": "لا عناصر",
      "count_one": "عنصر واحد",
      "count_two": "عنصران",
      "count_few": "{{count}} عناصر",
      "count_many": "{{count}} عنصرًا",
      "count_other": "{{count}} عنصر",
      "timetableConflicts": {
        "title": "تعارضات في جدول الأوقات",
        "meta": "قاعات أو أساتذة أو أفواج محجوزة مرتين هذا السداسي",
        "action": "معالجة"
      }
    },
    "payments": {
      "title": "آخر الدفوعات",
      "all": "عرض كل المقبوضات",
      "columns": {
        "student": "الطالب",
        "matricule": "المعرّف",
        "installment": "القسط",
        "mode": "الطريقة",
        "amount": "المبلغ",
        "date": "التاريخ",
        "status": "الحالة"
      }
    }
  },
  "errors": {
    "notFoundTitle": "الصفحة غير موجودة",
    "notFoundText": "العنوان المطلوب غير موجود أو تمّ نقله.",
    "forbiddenTitle": "النفاذ مرفوض",
    "forbiddenText": "دورك لا يسمح بالنفاذ إلى هذه الصفحة. اتصل بالإدارة عند الحاجة.",
    "tenantNotFoundTitle": "المؤسسة غير موجودة",
    "tenantNotFoundText": "تحقّق من العنوان: لكل مؤسسة عنوانها الخاص، مثلًا ecole.{{domain}}.",
    "loadFailedTitle": "تعذّر تحميل البيانات",
    "loadFailedText": "تحقّق من الاتصال ثم أعد المحاولة. إذا تواصل المشكل، اتصل بالدعم.",
    "goHome": "العودة إلى الرئيسية",
    "actionFailed": "لم تنجح العملية. أعد المحاولة بعد لحظة."
  },
  "student": {
    "hello": "مرحبًا،",
    "offline": "غير متصل · بيانات {{date}}",
    "offlineEmpty": "غير متصل. سجّل الدخول مرة أولى عبر الإنترنت لتصفح بياناتك دون شبكة.",
    "nav": {
      "label": "التنقل الرئيسي",
      "home": "الرئيسية",
      "notes": "الأعداد",
      "edt": "الجدول",
      "pay": "الدفعات",
      "more": "المزيد"
    },
    "home": {
      "next": "الحصة القادمة",
      "now": "الآن",
      "inMinutes": "بعد {{n}} دقيقة",
      "todayAt": "اليوم على الساعة {{time}}",
      "noNext": "لا توجد حصص قادمة",
      "average": "معدل السداسي {{n}}",
      "noAverage": "لا يوجد معدل بعد",
      "allPaid": "تم خلاص كل المعاليم",
      "absences": "غياب",
      "absencesToJustify": "غياب · {{hours}} للتبرير",
      "documents_zero": "وثيقة متاحة",
      "documents_one": "وثيقة متاحة",
      "documents_two": "وثيقتان متاحتان",
      "documents_few": "وثائق متاحة",
      "documents_many": "وثيقة متاحة",
      "documents_other": "وثيقة متاحة",
      "seeAll": "عرض الكل",
      "announcementsAria_zero": "الإعلانات، لا إعلانات غير مقروءة",
      "announcementsAria_one": "الإعلانات، إعلان واحد غير مقروء",
      "announcementsAria_two": "الإعلانات، إعلانان غير مقروءين",
      "announcementsAria_few": "الإعلانات، {{count}} إعلانات غير مقروءة",
      "announcementsAria_many": "الإعلانات، {{count}} إعلانًا غير مقروء",
      "announcementsAria_other": "الإعلانات، {{count}} إعلان غير مقروء"
    },
    "more": {
      "abs": "الغيابات",
      "docs": "الوثائق",
      "ann": "الإعلانات",
      "cal": "الرزنامة",
      "stages": "التربصات"
    },
    "notes": {
      "title": "أعدادي",
      "semesters": "السداسيات",
      "semester": "السداسي {{n}}",
      "average": "معدل السداسي",
      "provisional": "مؤقت",
      "provisionalHint": "نتائج مؤقتة: يُنشر القرار بعد مداولات اللجنة.",
      "credits_zero": "بدون أرصدة",
      "credits_one": "رصيد واحد",
      "credits_two": "رصيدان",
      "credits_few": "{{count}} أرصدة",
      "credits_many": "{{count}} رصيدًا",
      "credits_other": "{{count}} رصيد",
      "coef": "الضارب {{coef}}",
      "compensated": "بالتعويض",
      "emptyTitle": "لا أعداد بعد",
      "emptyText": "ستظهر أعدادك هنا فور نشرها.",
      "semesterShort": "س{{n}}"
    },
    "week": {
      "days": "أيام الأسبوع",
      "empty": "لا توجد حصص في هذا اليوم."
    },
    "pay": {
      "title": "الدفعات",
      "paidOf": "المدفوع من {{total}}",
      "progress": "نسبة المعاليم المدفوعة",
      "pending": "{{amount}} قيد الاستخلاص",
      "due": "الأجل {{date}}",
      "emptyTitle": "لا يوجد جدول دفعات",
      "emptyText": "سيظهر جدول الدفعات هنا بعد ترسيمك."
    },
    "abs": {
      "summary": "{{hours}} غياب · {{justified}} مبررة",
      "status": {
        "justified": "مبرر",
        "pending": "قيد التثبت",
        "unjustified": "غير مبرر"
      },
      "send": "إرسال مبرر",
      "sheetTitle": "إرسال مبرر",
      "alsoCover": "يشمل أيضًا",
      "photo": "التقاط صورة للمبرر",
      "photoHint": "صورة، JPG أو PNG أو PDF · 5 ميغابايت كحد أقصى",
      "change": "اضغط لتغيير الملف",
      "submit": "إرسال إلى إدارة الدراسة",
      "sent": "تم إرسال المبرر إلى إدارة الدراسة.",
      "failed": "تعذّر الإرسال. أعد المحاولة.",
      "badType": "صيغة غير مقبولة: JPG أو PNG أو PDF.",
      "emptyTitle": "لا غيابات",
      "emptyText": "ليس لديك أي غياب هذه السنة."
    },
    "docs": {
      "download": "تنزيل {{name}}",
      "empty": "لا توجد وثائق متاحة حاليًا.",
      "request": "طلب وثيقة",
      "requestHint": "شهادة حضور، تربص…",
      "kind": "نوع الوثيقة",
      "note": "توضيح (اختياري)",
      "notePlaceholder": "مثال: للصندوق الوطني للتأمين على المرض، نسختان",
      "send": "إرسال الطلب",
      "requested": "تم إرسال الطلب إلى إدارة الدراسة.",
      "duplicate": "يوجد طلب من هذا النوع قيد المعالجة.",
      "failed": "تعذّر الإرسال. أعد المحاولة.",
      "myRequests": "طلباتي"
    },
    "requestKinds": {
      "enrollment_certificate": "شهادة ترسيم",
      "attendance_certificate": "شهادة حضور",
      "transcript": "كشف أعداد",
      "internship": "اتفاقية تربص",
      "other": "وثيقة أخرى"
    },
    "requestStatus": {
      "pending": "قيد المعالجة",
      "done": "تمت المعالجة",
      "rejected": "مرفوض"
    },
    "ann": {
      "empty": "لا توجد إعلانات حاليًا."
    },
    "cal": {
      "empty": "لا تواريخ قادمة.",
      "showPast_zero": "لا تواريخ سابقة",
      "showPast_one": "عرض تاريخ سابق",
      "showPast_two": "عرض تاريخين سابقين",
      "showPast_few": "عرض {{count}} تواريخ سابقة",
      "showPast_many": "عرض {{count}} تاريخًا سابقًا",
      "showPast_other": "عرض {{count}} تاريخ سابق",
      "hidePast": "إخفاء التواريخ السابقة"
    },
    "stages": {
      "empty": "لا تربصات هذه السنة.",
      "emptyText": "صرّح بتربصك بمجرّد قبولك من المؤسسة: تصادق مصلحة الدراسة على الموضوع وتظهر الاتفاقية في وثائقك.",
      "declare": "التصريح بتربص",
      "declareHint": "تصادق مصلحة الدراسة على الموضوع. يمكنك اقتراح مؤطر وسيتلقّى مطلبًا.",
      "editTitle": "تعديل تربصي",
      "send": "إرسال للمصادقة",
      "askSupervisor": "اقتراح مؤطر",
      "askSupervisorHint": "يتلقّى الأستاذ المختار مطلبك ويقبله أو يرفضه.",
      "sendRequest": "إرسال المطلب",
      "convention": "اتفاقية تربصك متاحة في المزيد › الوثائق."
    }
  },
  "candidate": {
    "title": "متابعة ترشحك",
    "comingSoonText": "ستتوفر هنا المتابعة المفصّلة لملف التسجيل المسبق (المرحلة 4)."
  },
  "platform": {
    "title": "المؤسسات",
    "subtitle": "لوحة المنصة · {{count}} مؤسسات",
    "columns": {
      "name": "المؤسسة",
      "slug": "العنوان",
      "status": "الحالة",
      "users": "الحسابات",
      "students": "الطلبة",
      "createdAt": "تاريخ الإنشاء"
    },
    "status": {
      "active": "نشطة",
      "suspended": "معلّقة"
    },
    "create": "مؤسسة جديدة",
    "suspend": "تعليق",
    "reactivate": "إعادة التفعيل",
    "reinvite": "إعادة إرسال الدعوة",
    "created": "تم إنشاء المؤسسة. أُرسلت الدعوة.",
    "suspended": "تم تعليق المؤسسة.",
    "reactivated": "أُعيد تفعيل المؤسسة.",
    "reinvited": "أُعيد إرسال الدعوة.",
    "suspendTitle": "تعليق {{name}}؟",
    "suspendText": "لن يتمكن مستخدمو هذه المؤسسة من تسجيل الدخول.",
    "fields": {
      "slug": "العنوان (المعرّف)",
      "name": "التسمية القانونية",
      "shortName": "الاسم المختصر",
      "color": "اللون الرئيسي",
      "firstName": "اسم المسؤول",
      "lastName": "لقب المسؤول",
      "email": "بريد المسؤول",
      "yearLabel": "السنة الأولى",
      "startsOn": "الدخول",
      "s1EndsOn": "نهاية السداسي 1",
      "s2EndsOn": "نهاية السداسي 2",
      "endsOn": "نهاية السنة",
      "slugHelp": "أحرف لاتينية صغيرة وأرقام وشرطات (من 3 إلى 32). مثال: esprit."
    },
    "errors": {
      "generic": "رُفضت العملية.",
      "slug": "عنوان غير صالح: حروف وأرقام وشرطات، من 3 إلى 32 حرفًا.",
      "slugReserved": "هذا العنوان محجوز.",
      "required": "حقل إلزامي.",
      "shortName": "12 حرفًا على الأكثر.",
      "email": "بريد إلكتروني غير صالح."
    },
    "documentTitle": "وحدة التحكّم · {{product}}",
    "scope": "وحدة تحكّم المنصّة",
    "kpi": {
      "schools": "المؤسسات",
      "active_one": "{{count}} نشطة",
      "active_other": "{{count}} نشطة",
      "suspended": "معلّقة",
      "users": "الحسابات",
      "students": "الطلبة",
      "active_zero": "{{count}} نشطة",
      "active_two": "{{count}} نشطة",
      "active_few": "{{count}} نشطة",
      "active_many": "{{count}} نشطة"
    },
    "empty": "لا توجد مؤسسات. أنشئ الأولى عبر « مؤسسة جديدة ».",
    "sheet": {
      "label": "بطاقة المؤسسة",
      "address": "العنوان",
      "createdOn": "أُنشئت في {{date}}",
      "accounts": "الحسابات حسب الدور",
      "noAccounts": "لا توجد حسابات.",
      "admins": "المسؤولون",
      "noAdmin": "لا يوجد مسؤول.",
      "lastLogin": "آخر دخول في {{date}}",
      "neverLoggedIn": "لم يسجّل الدخول بعد",
      "open": "فتح الفضاء",
      "studentRecords": "ملفات الطلبة"
    },
    "adminState": {
      "invited": "دعوة في الانتظار",
      "active": "نشط",
      "disabled": "معطّل"
    },
    "reinviteTitle": "إعادة إرسال الدعوة؟",
    "reinviteText": "سيُرسل رابط جديد إلى {{email}}. تبقى الروابط السابقة صالحة حتى انتهاء مدتها.",
    "nav": {
      "label": "أقسام وحدة التحكّم",
      "schools": "المؤسسات",
      "journal": "السجلّ"
    },
    "journalSubtitle": "المؤسسات المنشأة والمعلّقة والمعاد تفعيلها والدعوات المعاد إرسالها وتغييرات كلمة مرور وحدة التحكّم."
  },
  "public": {
    "applyTitle": "التسجيل المسبق عبر الإنترنت",
    "applyText": "سيتوفر هنا نموذج التسجيل المسبق العمومي (المرحلة 4)."
  },
  "enrollmentStatus": {
    "en_cours": "مرسّم",
    "en_cours_F": "مرسّمة",
    "admis": "ناجح",
    "admis_F": "ناجحة",
    "ajourne": "راسب",
    "ajourne_F": "راسبة",
    "abandon": "منقطع",
    "abandon_F": "منقطعة",
    "none": "غير مرسّم",
    "none_F": "غير مرسّمة",
    "current": "جارية"
  },
  "students": {
    "title": "الطلبة",
    "subtitle": "{{count}} طالبًا · السنة {{year}}",
    "new": "طالب جديد",
    "search": "الاسم، رقم بطاقة التعريف أو المعرّف",
    "filters": {
      "program": "الشعبة",
      "level": "المستوى",
      "group": "الفوج",
      "status": "الحالة",
      "allPrograms": "كل الشعب",
      "allLevels": "كل المستويات",
      "allGroups": "كل الأفواج",
      "allStatuses": "كل الحالات"
    },
    "columns": {
      "matricule": "المعرّف",
      "name": "الاسم واللقب",
      "program": "الشعبة",
      "level": "المستوى",
      "group": "الفوج",
      "status": "الحالة"
    },
    "selection_zero": "لم يتمّ اختيار أي طالب",
    "selection_one": "تمّ اختيار طالب واحد",
    "selection_two": "تمّ اختيار طالبين",
    "selection_few": "تمّ اختيار {{count}} طلبة",
    "selection_many": "تمّ اختيار {{count}} طالبًا",
    "selection_other": "تمّ اختيار {{count}} طالب",
    "clearSelection": "إلغاء الاختيار",
    "changeGroup": "تغيير الفوج",
    "changeGroupHint": "اختر طلبة من نفس المستوى لتغيير فوجهم.",
    "changeGroupTitle": "تغيير الفوج · {{count}} طالب",
    "groupChanged": "تمّ نقل {{count}} طالب إلى الفوج {{group}}.",
    "openRecord": "فتح الملف",
    "emptyTitle": "لا يوجد طلبة لهذه المعايير",
    "emptyText": "عدّل المعايير أو أعد تعيين البحث لعرض كل الطلبة.",
    "errors": {
      "required": "حقل إجباري.",
      "cin": "يجب أن يتكوّن رقم بطاقة التعريف من 8 أرقام.",
      "email": "بريد إلكتروني غير صالح.",
      "phone": "رقم هاتف غير صالح.",
      "date": "تاريخ غير صالح.",
      "average": "يجب أن يكون المعدل بين 0 و20.",
      "level": "اختر مستوى.",
      "duplicateCin": "يوجد طالب بنفس رقم بطاقة التعريف.",
      "save": "تعذّر الحفظ. تحقّق من الحقول ثم أعد المحاولة."
    },
    "import": {
      "open": "استيراد",
      "title": "استيراد الطلبة · {{year}}",
      "intro": "سطر لكل طالب. اللقب والاسم والمستوى إجبارية، وبقية أعمدة النموذج اختيارية. الطالب المعروف مسبقًا (نفس المعرّف أو نفس بطاقة التعريف) لا تُغيَّر بطاقته: يُسجَّل فقط للسنة.",
      "pick": "اختر ملف Excel ‏(.xlsx)",
      "hint": "أو اسحبه إلى هنا · 2000 سطر على الأكثر",
      "analysing": "جارٍ قراءة الملف…",
      "detected_zero": "لم يُقرأ أي سطر",
      "detected_one": "تمت قراءة سطر واحد",
      "detected_two": "تمت قراءة سطرين",
      "detected_few": "تمت قراءة {{formatted}} أسطر",
      "detected_many": "تمت قراءة {{formatted}} سطرًا",
      "detected_other": "تمت قراءة {{formatted}} سطر",
      "template": "تنزيل النموذج",
      "apply_zero": "استيراد",
      "apply_one": "استيراد طالب واحد",
      "apply_two": "استيراد طالبين",
      "apply_few": "استيراد {{count}} طلبة",
      "apply_many": "استيراد {{count}} طالبًا",
      "apply_other": "استيراد {{count}} طالب",
      "applied": "اكتمل الاستيراد.",
      "toCreate_zero": "لن يُنشأ أي طالب",
      "toCreate_one": "سيُنشأ طالب جديد ويُسجَّل",
      "toCreate_two": "سيُنشأ طالبان جديدان ويُسجَّلان",
      "toCreate_few": "سيُنشأ {{count}} طلبة جدد ويُسجَّلون",
      "toCreate_many": "سيُنشأ {{count}} طالبًا جديدًا ويُسجَّلون",
      "toCreate_other": "سيُنشأ {{count}} طالب جديد ويُسجَّلون",
      "created_zero": "لم يُنشأ أي طالب",
      "created_one": "أُنشئ طالب واحد وسُجّل",
      "created_two": "أُنشئ طالبان وسُجّلا",
      "created_few": "أُنشئ {{count}} طلبة وسُجّلوا",
      "created_many": "أُنشئ {{count}} طالبًا وسُجّلوا",
      "created_other": "أُنشئ {{count}} طالب وسُجّلوا",
      "toEnroll_zero": "لا أحد",
      "toEnroll_one": "سيُسجَّل طالب معروف للسنة",
      "toEnroll_two": "سيُسجَّل طالبان معروفان للسنة",
      "toEnroll_few": "سيُسجَّل {{count}} طلبة معروفون للسنة",
      "toEnroll_many": "سيُسجَّل {{count}} طالبًا معروفًا للسنة",
      "toEnroll_other": "سيُسجَّل {{count}} طالب معروف للسنة",
      "enrolled_zero": "لا أحد",
      "enrolled_one": "سُجّل طالب معروف للسنة",
      "enrolled_two": "سُجّل طالبان معروفان للسنة",
      "enrolled_few": "سُجّل {{count}} طلبة معروفون للسنة",
      "enrolled_many": "سُجّل {{count}} طالبًا معروفًا للسنة",
      "enrolled_other": "سُجّل {{count}} طالب معروف للسنة",
      "skipped_zero": "لا أحد",
      "skipped_one": "طالب مسجّل مسبقًا هذه السنة: تم تجاهله",
      "skipped_two": "طالبان مسجّلان مسبقًا هذه السنة: تم تجاهلهما",
      "skipped_few": "{{count}} طلبة مسجّلون مسبقًا هذه السنة: تم تجاهلهم",
      "skipped_many": "{{count}} طالبًا مسجّلًا مسبقًا هذه السنة: تم تجاهلهم",
      "skipped_other": "{{count}} طالب مسجّل مسبقًا هذه السنة: تم تجاهلهم",
      "rejected_zero": "لا أسطر",
      "rejected_one": "سطر واحد يجب تصحيحه: لن يُستورد",
      "rejected_two": "سطران يجب تصحيحهما: لن يُستوردا",
      "rejected_few": "{{count}} أسطر يجب تصحيحها: لن تُستورد",
      "rejected_many": "{{count}} سطرًا يجب تصحيحها: لن تُستورد",
      "rejected_other": "{{count}} سطر يجب تصحيحها: لن تُستورد",
      "invited_zero": "لم يُرسل أي بريد",
      "invited_one": "أُرسل بريد دخول واحد",
      "invited_two": "أُرسل بريدا دخول",
      "invited_few": "أُرسلت {{count}} رسائل دخول",
      "invited_many": "أُرسلت {{count}} رسالة دخول",
      "invited_other": "أُرسلت {{count}} رسالة دخول",
      "invite": "إرسال رابط الدخول إلى الفضاء الطلابي للطلبة المنشئين (الذين لديهم بريد إلكتروني)",
      "done": "أُنشئ {{created}}، سُجّل {{enrolled}}",
      "line": "السطر",
      "problem": "يجب تصحيحه",
      "errors": {
        "file": "تعذّرت قراءة هذا الملف. احفظه بصيغة Excel ‏(.xlsx) وأعد المحاولة.",
        "columns": "الأعمدة غير موجودة: يجب أن يحتوي السطر الأول على الأقل على Nom وPrénom وNiveau. انطلق من النموذج.",
        "empty": "لا يحتوي الملف على أي طالب.",
        "too_many": "أكثر من 2000 سطر: قسّم الملف (حسب الشعبة أو المستوى).",
        "year_closed": "هذه السنة الجامعية مغلقة: اختر السنة الجارية.",
        "size": "الملف كبير جدًا (1 ميغابايت على الأكثر)."
      },
      "rowErrors": {
        "required": "إجباري",
        "level": "مستوى غير معروف (انظر ورقة Listes في النموذج)",
        "group": "فوج غير معروف لهذا المستوى وهذه السنة",
        "matricule": "معرّف غير معروف",
        "duplicate": "مكرّر في الملف",
        "cin_taken": "بطاقة التعريف مستعملة من قبل أستاذ",
        "duplicate_cin": "بطاقة التعريف مستعملة",
        "date": "تاريخ غير صالح (يوم/شهر/سنة)",
        "gender": "F أو M",
        "number": "رقم غير صالح",
        "cin": "8 أرقام",
        "email": "بريد إلكتروني غير صالح",
        "phone": "هاتف غير صالح",
        "average": "معدّل بين 0 و20",
        "already_enrolled": "مسجّل هذه السنة",
        "year_closed": "سنة مغلقة",
        "internal": "خطأ غير متوقّع",
        "invalid": "قيمة غير صالحة",
        "other_student": "يخصّ طالبًا آخر ({{ref}}): تحقّق من الاسم أو الرقم"
      },
      "homonyms_zero": "لا تشابه في الأسماء",
      "homonyms_one": "تشابه واحد في الاسم يجب التحقّق منه",
      "homonyms_two": "تشابهان في الأسماء يجب التحقّق منهما",
      "homonyms_few": "{{count}} تشابهات في الأسماء يجب التحقّق منها",
      "homonyms_many": "{{count}} تشابهًا في الأسماء يجب التحقّق منه",
      "homonyms_other": "{{count}} تشابه في الأسماء يجب التحقّق منه",
      "homonymLine": "السطر {{row}} · {{name}}: نفس اسم {{ref}}. إذا كان الشخص نفسه، أدخل معرّفه لتسجيله بدل إنشاء بطاقة جديدة."
    },
    "access": {
      "action": "إرسال رابط الدخول",
      "title_zero": "إرسال رابط الدخول",
      "title_one": "إرسال رابط الدخول إلى الفضاء الطلابي",
      "title_two": "إرسال رابط الدخول إلى طالبين",
      "title_few": "إرسال رابط الدخول إلى {{count}} طلبة",
      "title_many": "إرسال رابط الدخول إلى {{count}} طالبًا",
      "title_other": "إرسال رابط الدخول إلى {{count}} طالب",
      "text": "يتلقّى كل طالب عبر البريد الإلكتروني معرّفه ورابطًا لاختيار كلمة المرور، صالحًا لمدة {{days}} أيام. الطلبة دون بريد إلكتروني لا يتلقّون شيئًا.",
      "confirm": "إرسال",
      "sent_zero": "لم يُرسل أي بريد",
      "sent_one": "أُرسل بريد واحد",
      "sent_two": "أُرسل بريدان",
      "sent_few": "أُرسلت {{count}} رسائل",
      "sent_many": "أُرسلت {{count}} رسالة",
      "sent_other": "أُرسلت {{count}} رسالة",
      "withoutEmail_zero": "لا أحد دون بريد",
      "withoutEmail_one": "طالب دون بريد إلكتروني",
      "withoutEmail_two": "طالبان دون بريد إلكتروني",
      "withoutEmail_few": "{{count}} طلبة دون بريد إلكتروني",
      "withoutEmail_many": "{{count}} طالبًا دون بريد إلكتروني",
      "withoutEmail_other": "{{count}} طالب دون بريد إلكتروني"
    }
  },
  "record": {
    "crumb": "الدراسة",
    "tabs": {
      "info": "المعطيات",
      "enrollments": "الترسيمات",
      "grades": "الأعداد",
      "absences": "الغيابات",
      "finance": "المالية",
      "documents": "الوثائق",
      "history": "السجل"
    },
    "attest": "شهادة ترسيم",
    "releve": "كشف الأعداد",
    "statusLine": "{{status}} · {{year}}",
    "groupLine": "{{level}} · الفوج {{group}}",
    "cycle": {
      "ingenieur": "مرحلة المهندسين",
      "licence": "الإجازة",
      "master": "الماجستير"
    },
    "facts": {
      "average": "المعدل",
      "credits": "الأرصدة المصادق عليها (اللجنة)",
      "absences": "الغيابات {{year}}",
      "balance": "المبلغ المتبقي",
      "averageSem": "معدل السداسي {{n}}"
    },
    "sections": {
      "identity": "الهوية",
      "contact": "الاتصال",
      "bac": "الباكالوريا",
      "guardian": "الوليّ"
    },
    "fields": {
      "lastName": "اللقب",
      "firstName": "الاسم",
      "lastNameAr": "اللقب (بالعربية)",
      "firstNameAr": "الاسم (بالعربية)",
      "cin": "رقم بطاقة التعريف",
      "gender": "الجنس",
      "birthDate": "تاريخ الولادة",
      "birthPlace": "مكان الولادة",
      "nationality": "الجنسية",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "address": "العنوان",
      "city": "المدينة",
      "bacSection": "الشعبة",
      "bacSession": "الدورة",
      "bacYear": "السنة",
      "bacAverage": "المعدل",
      "bacSchool": "المعهد",
      "guardianName": "الاسم",
      "guardianRelation": "الصلة",
      "guardianPhone": "الهاتف",
      "guardianProfession": "المهنة"
    },
    "genders": {
      "F": "أنثى",
      "M": "ذكر"
    },
    "editTitle": "تعديل · {{section}}",
    "saved": "تمّ تحديث الملف.",
    "enrollmentsHead": {
      "year": "السنة",
      "level": "المستوى",
      "group": "الفوج",
      "date": "تاريخ الترسيم",
      "credits": "الأرصدة",
      "decision": "القرار"
    },
    "newEnrollment": "ترسيم جديد",
    "enrollTitle": "الترسيم {{year}}",
    "enrolled": "تمّ تسجيل الترسيم.",
    "changeGroup": "تغيير الفوج",
    "groupChanged": "تمّ تغيير الفوج.",
    "noGroup": "بدون فوج",
    "alreadyEnrolled": "الطالب مرسّم مسبقًا لهذه السنة.",
    "comingTitle": "قريبًا",
    "comingText": "سيتمّ تفعيل هذا القسم في المرحلة {{phase}}.",
    "historyEmpty": "لا توجد أحداث مسجّلة.",
    "grades": {
      "empty": "لا توجد أعداد حاليًا",
      "semester": "س{{n}} · {{year}}",
      "semAvg": "معدل السداسي:",
      "live": "نتائج وقتية محتسبة من الأعداد المُدخلة (قبل المداولات).",
      "frozen": "نتائج أقرّتها اللجنة · {{session}}.",
      "notPublished": "ستظهر النتائج بعد نشر المحضر.",
      "head": {
        "unit": "الوحدة / العنصر",
        "coef": "الضارب",
        "credits": "الأرصدة",
        "average": "المعدل",
        "result": "النتيجة"
      },
      "acq": "مكتسبة",
      "comp": "بالتعويض",
      "nacq": "غير مكتسبة"
    },
    "notFoundTitle": "الطالب غير موجود",
    "notFoundText": "هذا الملف غير موجود أو حُذف أو خارج نطاق صلاحياتك."
  },
  "history": {
    "student_create": "إنشاء الملف (المعرّف {{matricule}})",
    "student_update": "تعديل الملف: {{fields}}",
    "enrollment_create": "المصادقة على الترسيم في {{level}} ({{year}})",
    "enrollment_group_change": "تغيير الفوج: الفوج {{group}}",
    "enrollment_update": "تحديث الترسيم",
    "unknown": "حدث: {{action}}",
    "meta": "{{date}} · {{actor}}",
    "system": "النظام",
    "document_issue": "صدرت وثيقة {{typeLabel}} · {{code}}",
    "document_revoke": "أُلغيت وثيقة: {{reason}}",
    "document_send": "أُرسلت وثيقة بالبريد إلى الطالب",
    "jury_decision": "عدّلت اللجنة القرار: {{decisionLabel}}",
    "computedDecision": "القرار المحتسب",
    "absence_justify": "تبرير غيابات ({{records}} حصة)",
    "absence_justify_reject": "رفض المبرر",
    "document_request_done": "تمت معالجة الطلب: {{kindLabel}}",
    "document_request_rejected": "رفض الطلب: {{kindLabel}}",
    "payment_create": "تسجيل دفعة: {{amountLabel}} ({{methodLabel}})",
    "payment_cancel": "إلغاء دفعة: {{amountLabel}}"
  },
  "newStudent": {
    "title": "طالب جديد",
    "subtitle": "يتمّ إنشاء المعرّف وحساب الدخول آليًا.",
    "enrollment": "الترسيم {{year}}",
    "submit": "إنشاء الملف",
    "created": "تمّ إنشاء الملف {{matricule}}.",
    "footerHint": "ترسيم {{year}} · يُسند المعرّف عند الإنشاء."
  },
  "curriculum": {
    "title": "عرض التكوين",
    "listSubtitle": "مسالك إمد حسب الشعبة · الإصدارات والتأهيل",
    "new": "مسلك جديد",
    "columns": {
      "program": "الشعبة",
      "name": "المسلك",
      "version": "الإصدار",
      "status": "الحالة",
      "credits": "الأرصدة",
      "habilitation": "التأهيل",
      "enrollments": "المرسّمون"
    },
    "status": {
      "draft": "مسودة",
      "published": "منشور"
    },
    "versionLabel": "الإصدار {{version}}",
    "subtitle": "نظام إمد · {{semesters}} سداسيات · {{credits}} رصيدًا",
    "habilitation": " · التأهيل {{from}}-{{to}}",
    "addUnit": "إضافة وحدة إلى السداسي {{index}}",
    "publish": "نشر العرض",
    "publishTip": "صحّح مجموع الأرصدة للنشر",
    "publishedToast": "تمّ نشر عرض التكوين — يُستعمل للترسيمات الجديدة.",
    "newVersion": "إنشاء إصدار جديد",
    "newVersionToast": "تمّ إنشاء الإصدار {{version}} كمسودة.",
    "openDraft": "فتح المسودة",
    "readOnly": "إصدار منشور للقراءة فقط. أنشئ إصدارًا جديدًا لتعديله.",
    "warnItem": "السداسي {{index}}: {{credits}} رصيدًا من {{target}}",
    "warnText": "يجب أن يساوي مجموع كل سداسي 30 رصيدًا بالضبط قبل النشر. عدّل أرصدة عنصر أو أضف وحدة.",
    "okText": "مجموع كل السداسيات 30 رصيدًا. يمكن نشر العرض.",
    "head": {
      "structure": "الهيكلة",
      "nature": "الطبيعة",
      "credits": "الأرصدة",
      "coef": "الضارب",
      "regime": "النظام"
    },
    "root": "مسلك {{program}} · {{credits}} رصيدًا",
    "semester": "السداسي {{index}}",
    "choice": "(اختياري)",
    "natures": {
      "F": "أساسية",
      "T": "أفقية",
      "O": "اختيارية"
    },
    "regimes": {
      "MIXTE": "مختلط",
      "CC": "مراقبة مستمرة",
      "EXAM": "امتحان نهائي"
    },
    "regimeHint": {
      "MIXTE": "المعدل = {{cc}} % مراقبة مستمرة + {{exam}} % امتحان نهائي.",
      "CC": "المعدل محسوب على المراقبة المستمرة فقط؛ لا يوجد امتحان نهائي.",
      "EXAM": "المعدل = الامتحان النهائي فقط."
    },
    "inspector": {
      "empty": "اختر وحدة أو عنصرًا لتعديل إعداداته.",
      "unitKind": "وحدة تعليمية · {{code}}",
      "courseKind": "عنصر · {{code}}",
      "name": "العنوان",
      "nameAr": "العنوان (بالعربية)",
      "code": "الرمز",
      "nature": "طبيعة الوحدة",
      "unitCredits": "أرصدة الوحدة (مجموع العناصر)",
      "unitCreditsOptional": "أرصدة الوحدة (عنصر واحد اختياري)",
      "unitHint": "معدل الوحدة هو المعدل الموزون لعناصرها حسب الضوارب.",
      "eliminatory": "العدد الإقصائي للوحدة",
      "eliminatoryHint": "فارغ: قاعدة المؤسسة.",
      "credits": "الأرصدة",
      "coef": "الضارب",
      "regime": "نظام التقييم",
      "hours": "الحجم الساعي",
      "cm": "درس",
      "td": "أعمال موجهة",
      "tp": "أعمال تطبيقية",
      "addCourse": "إضافة عنصر",
      "newCourse": "عنصر جديد",
      "less": "أقل",
      "more": "أكثر"
    },
    "addUnitTitle": "وحدة جديدة · السداسي {{index}}",
    "add": "إضافة",
    "unitAdded": "تمّت إضافة الوحدة « {{name}} » إلى السداسي {{index}}.",
    "deleteTitle": "حذف « {{name}} »؟",
    "deleteText": "سيُعاد احتساب أرصدة السداسي.",
    "deleted": "تمّ الحذف. أُعيد احتساب الأرصدة.",
    "newTitle": "مسلك جديد",
    "program": "الشعبة",
    "name": "عنوان المسلك",
    "from": "التأهيل من",
    "to": "إلى",
    "createDraft": "إنشاء المسودة",
    "enrollmentsCount": "{{count}} مرسّم",
    "errors": {
      "unitCode": "الرمز المنتظر: من 2 إلى 4 أحرف ثم من 1 إلى 3 أرقام (مثال UEF35).",
      "nameRequired": "أدخل عنوانًا.",
      "duplicate": "هذا الرمز موجود في المسلك.",
      "draftExists": "توجد مسودة لهذه الشعبة.",
      "published": "هذا الإصدار منشور: أنشئ إصدارًا جديدًا لتعديله.",
      "save": "رُفض التعديل. تحقّق من القيمة ثم أعد المحاولة."
    }
  },
  "reference": {
    "errors": {
      "programCode": "رمز من 2 إلى 4 أحرف كبيرة.",
      "groupName": "اسم الفوج: من 1 إلى 3 أحرف."
    }
  },
  "settings": {
    "navLabel": "أقسام الإعدادات",
    "save": "حفظ التعديلات",
    "saveStatus": {
      "saving": "جارٍ الحفظ…",
      "saved": "تم حفظ التعديلات",
      "error": "تعذّر الحفظ"
    },
    "nav": {
      "etablissement": "المؤسسة",
      "identite": "الهوية البصرية",
      "annees": "السنوات الجامعية",
      "roles": "الأدوار والصلاحيات",
      "regles": "قواعد التنقيط",
      "structure": "الهيكل"
    },
    "errors": {
      "generic": "رُفض التعديل. راجع القيم ثم أعد المحاولة.",
      "version": "تغيّرت هذه الإعدادات في الأثناء. أعد تحميل الصفحة.",
      "defaultLocale": "يجب أن تبقى اللغة الافتراضية مفعّلة.",
      "color": "لون غير صالح.",
      "contrast": "التباين غير كافٍ: اختر درجة أغمق (الحد الأدنى 4,5:1).",
      "thresholds": "يجب أن يبقى حد المراقبة أقل من التنبيه أو مساويًا له، والتنبيه أقل من حد الإقصاء أو مساويًا له.",
      "weekdays": "اختر يومًا واحدًا على الأقل.",
      "slots": "يجب ألا تتداخل الحصص، وأن تنتهي بعد بدايتها.",
      "eliminatory": "يجب أن تكون نقطة الإقصاء أقل من معدل النجاح.",
      "yearDates": "يجب أن تتتابع التواريخ: الدخول، نهاية س1، نهاية س2، نهاية السنة.",
      "yearLabel": "الصيغة المنتظرة: سسسس-سسسس، ويجب أن تكون فريدة.",
      "yearOrder": "يجب أن تبدأ السنة الجديدة بعد آخر سنة.",
      "yearStatus": "هذا الإجراء غير ممكن في الوضع الحالي للسنة.",
      "matriculePattern": "صيغة المعرّف غير صالحة."
    },
    "establishment": {
      "name": "التسمية القانونية",
      "shortName": "الاسم المختصر",
      "agrementNo": "رقم الاعتماد",
      "address": "العنوان",
      "phone": "الهاتف",
      "email": "بريد التسجيل",
      "locales": "لغات الواجهة",
      "localesHint": "انقر لغة لتفعيلها أو إزالتها. «افتراضي» يختارها من بين اللغات المفعّلة.",
      "default": "افتراضي",
      "makeDefault": "افتراضي",
      "saved": "تم حفظ المؤسسة."
    },
    "brand": {
      "subtitle": "يُطبَّق اللون الرئيسي فورًا على التطبيق كله والوثائق الرسمية وفضاء الطالب.",
      "logo": "الشعار",
      "replace": "استبدال",
      "remove": "إزالة",
      "logoHint": "PNG أو JPEG، 1 ميغا كحد أقصى",
      "logoSaved": "تم تحديث الشعار.",
      "logoType": "ملف مرفوض: PNG أو JPEG فقط.",
      "logoSize": "حجم الملف أكبر من 1 ميغا.",
      "color": "اللون الرئيسي",
      "custom": "لون مخصص",
      "swatches": {
        "indigo": "نيلي",
        "blue": "أزرق مؤسسي",
        "teal": "أزرق مخضر",
        "green": "أخضر",
        "bordeaux": "خمري",
        "gold": "ذهبي (تباين غير كافٍ)"
      },
      "contrastOk": "تباين النص الأبيض: {{ratio}}:1 — مطابق لـ WCAG AA.",
      "contrastFail": "تباين النص الأبيض: {{ratio}}:1 — غير كافٍ (الحد الأدنى 4,5:1). اختر درجة أغمق.",
      "preview": "معاينة مباشرة",
      "dashboard": "لوحة القيادة",
      "newEnrollment": "تسجيل جديد",
      "export": "تصدير",
      "tabInfo": "معلومات",
      "tabGrades": "الأعداد",
      "transcript": "كشف الأعداد",
      "letterhead": "ترويسة الوثائق الرسمية",
      "saved": "تم حفظ اللون."
    },
    "years": {
      "new": "سنة جديدة",
      "empty": "لا توجد سنة جامعية.",
      "rentree": "الدخول {{date}}",
      "closedOn": "أُغلقت في {{date}}",
      "untilS1": "س1 إلى {{date}}",
      "untilS2": "س2 إلى {{date}}",
      "activate": "فتح",
      "archive": "أرشفة",
      "delete": "حذف",
      "deleteBlocked": "غير ممكن: توجد تسجيلات.",
      "activateTitle": "فتح {{label}}؟",
      "activateText": "تصبح السنة الجارية. تُغلق السنة الجارية الحالية.",
      "archiveTitle": "أرشفة {{label}}؟",
      "archiveText": "تبقى السنة المؤرشفة قابلة للاطلاع ولا يمكن تعديلها.",
      "deleteTitle": "حذف {{label}}؟",
      "deleteText": "يُحذف المسودّة وما نُسخ من الأفواج أو التعريفات أو الحصص.",
      "activated": "تم فتح السنة.",
      "archived": "تمت أرشفة السنة.",
      "deleted": "تم حذف المسودّة.",
      "created": "أُنشئت السنة · {{groups}} أفواج، {{fees}} تعريفات، {{slots}} حصص.",
      "dialogTitle": "سنة جامعية جديدة",
      "label": "التسمية",
      "startsOn": "الدخول",
      "s1EndsOn": "نهاية السداسي 1",
      "s2EndsOn": "نهاية السداسي 2",
      "endsOn": "نهاية السنة",
      "copyGroups": "نسخ الأفواج",
      "copyFees": "نسخ التعريفات",
      "copySlots": "نسخ حصص الجدول",
      "helper": "يبقى عرض التكوين المنشور ساريًا: المسارات غير مرتبطة بالسنة ولا تُنسخ. يمكن نسخ الأفواج والتعريفات من آخر سنة (تُرحَّل آجال التعريفات بسنة). لا تُنسخ حصص الجدول إلا إذا طلبت ذلك.",
      "create": "إنشاء السنة"
    },
    "roles": {
      "subtitle": "انقر خانة لمنح صلاحية أو سحبها.",
      "module": "الوحدة",
      "locked": "غير قابل للتعديل",
      "cycle": "انقر للتغيير",
      "saveFailed": "لم يُغيَّر الحق.",
      "level": {
        "edit": "تحرير",
        "read": "اطلاع",
        "own": "خاصّه",
        "none": "لا شيء"
      },
      "short": {
        "ADMIN_ECOLE": "الإدارة",
        "AGENT_SCOLARITE": "التسجيل",
        "AGENT_FINANCE": "المالية",
        "ENSEIGNANT": "أستاذ",
        "ETUDIANT": "طالب",
        "CANDIDAT": "مترشح"
      },
      "cellLabel": "{{module}} — {{role}}: {{level}}",
      "accounts_zero": "{{n}} حساب",
      "accounts_one": "{{n}} حساب",
      "accounts_two": "{{n}} حسابان",
      "accounts_few": "{{n}} حسابات",
      "accounts_many": "{{n}} حسابًا",
      "accounts_other": "{{n}} حساب"
    },
    "modules": {
      "dashboard": "لوحة القيادة",
      "admissions": "الترشحات",
      "students": "ملفات الطلبة",
      "curriculum": "عرض التكوين",
      "timetable": "جدول الأوقات",
      "attendance": "الغيابات",
      "grades": "إدخال الأعداد",
      "deliberations": "المداولات",
      "documents": "كشوف وشهائد",
      "finance": "المالية",
      "announcements": "الإعلانات",
      "settings": "الإعدادات",
      "audit": "سجل التدقيق",
      "internships": "التربصات ومشاريع التخرج"
    },
    "rules": {
      "title": "قواعد التنقيط والمداولة",
      "passMark": "معدل النجاح",
      "passMarkHint": "على 20، لكل سداسي",
      "eliminatory": "نقطة إقصاء الوحدة",
      "eliminatoryHint": "تمنع التعويض",
      "weights": "ترجيح الفرض / التطبيقي / الامتحان",
      "weightsHint": "النظام المختلط، بالنسبة المئوية",
      "weightsSum": "يجب أن يكون مجموع الأجزاء الثلاثة 100٪.",
      "ds": "فرض",
      "tp": "تطبيقي",
      "exam": "امتحان",
      "elimination": "حد الإقصاء (غيابات)",
      "eliminationHint": "غيابات غير مبررة لكل عنصر. فارغ = لا إقصاء.",
      "alert": "حد التنبيه (غيابات)",
      "alertHint": "إشعار تلقائي",
      "watch": "حد المراقبة",
      "watchHint": "يجب أن يبقى أقل من حد التنبيه أو مساويًا له",
      "rounding": "تقريب المعدلات",
      "roundingHint": "في كل مستوى: المعدلات المقربة تغذي الحساب التالي. في النهاية فقط: دقة كاملة، والتقريب للعرض.",
      "roundingMode": {
        "each_level": "في كل مستوى",
        "final": "في النهاية فقط"
      },
      "compensation": "التعويض بين وحدات السداسي نفسه",
      "compensationHint": "يُكتسب السداسي إذا كان المعدل ≥ 10 ولا توجد وحدة إقصائية",
      "retake": "الإبقاء على أفضل عدد في دورة الاستدراك",
      "retakeHint": "وإلا يحل عدد الاستدراك محل العدد الأول",
      "publish": "نشر النتائج تلقائيًا",
      "publishHint": "بمجرد إمضاء المحضر من رئيس اللجنة",
      "timetableTitle": "جدول الأوقات",
      "weekdays": "أيام الدراسة",
      "weekdaysHint": "يوم واحد على الأقل",
      "weekday": {
        "1": "إث",
        "2": "ثل",
        "3": "أر",
        "4": "خم",
        "5": "جم",
        "6": "سب",
        "7": "أحد"
      },
      "slots": "الحصص",
      "slotsHint": "ساعة البداية والنهاية، دون تداخل",
      "slotStart": "البداية",
      "slotEnd": "النهاية",
      "addSlot": "إضافة حصة",
      "removeSlot": "حذف الحصة",
      "featuresTitle": "وظائف قادمة",
      "featuresHint": "تبقى هذه الخيارات بلا أثر إلى أن يُربط مزوّد.",
      "feature": {
        "onlinePayment": "الدفع عبر الإنترنت",
        "smsReminders": "تذكيرات SMS",
        "whatsappReminders": "تذكيرات واتساب",
        "sso": "دخول موحّد (SSO)"
      },
      "documentsTitle": "الوثائق والمعرّفات",
      "signatoryName": "الموقّع",
      "signatoryTitle": "صفة الموقّع",
      "city": "المدينة (« حُرّر بـ »)",
      "matricule": "صيغة المعرّف",
      "matriculeHint": "{YY}{PROGRAM}{SEQ:4}",
      "saved": "تم حفظ القواعد.",
      "eliminationBarsExam": "الإقصاء بسبب الغيابات: الدورة الاستدراكية إجبارية",
      "eliminationBarsExamHint": "المادة المقصاة لا تُحتسب في الدورة الرئيسية وتمنع التعويض",
      "reviewDays": "مطالب مراجعة الأعداد",
      "reviewDaysHint": "الأجل الممنوح للطلبة بعد نشر نتائج الدورة.",
      "reviewDaysValue_zero": "0 يوم",
      "reviewDaysValue_one": "يوم واحد",
      "reviewDaysValue_two": "يومان",
      "reviewDaysValue_few": "{{count}} أيام",
      "reviewDaysValue_many": "{{count}} يومًا",
      "reviewDaysValue_other": "{{count}} يوم",
      "reviewDaysOff": "معطّلة"
    },
    "structure": {
      "programs": "الشعب",
      "groups": "الأفواج",
      "rooms": "القاعات",
      "addProgram": "شعبة جديدة",
      "addGroup": "فوج جديد",
      "addRoom": "قاعة جديدة",
      "editRoom": "تعديل القاعة",
      "empty": "لا يوجد عنصر.",
      "noYear": "اختر سنة جامعية من الشريط العلوي.",
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "cycle": "الدورة",
      "duration": "المدة (سنوات)",
      "years": "{{n}} سنوات",
      "capacity": "السعة",
      "seats": "{{size}} / {{capacity}}",
      "level": "المستوى",
      "groupName": "اسم الفوج",
      "kind": "النوع",
      "status": "الحالة",
      "active": "نشطة",
      "inactive": "غير نشطة",
      "create": "إنشاء",
      "programCreated": "تم إنشاء الشعبة.",
      "groupCreated": "تم إنشاء الفوج.",
      "roomSaved": "تم حفظ القاعة.",
      "cycles": {
        "ingenieur": "هندسة",
        "licence": "إجازة",
        "master": "ماجستير"
      },
      "kinds": {
        "amphi": "مدرج",
        "salle": "قاعة",
        "labo": "مخبر"
      }
    }
  },
  "grades": {
    "mySheets": "أوراق أعدادي",
    "listSubtitle": "أوراق الأعداد · {{year}}",
    "empty": "لا توجد أوراق أعداد",
    "emptyText": "تظهر الأوراق هنا بمجرّد فتح دورات الامتحانات.",
    "notFound": "ورقة الأعداد غير موجودة",
    "groupLabel": "{{level}} · الفوج {{group}}",
    "groupLong": "{{level}} الفوج {{group}}",
    "semester": "السداسي {{n}}",
    "formula": "المعدل = {{weights}}",
    "session": {
      "principale": "الدورة الرئيسية",
      "rattrapage": "دورة التدارك"
    },
    "status": {
      "brouillon": "مسودة",
      "transmis": "مُحال"
    },
    "kinds": {
      "DS": "فرض",
      "TP": "أشغال تطبيقية",
      "EXAM": "امتحان",
      "RATTRAPAGE": "تدارك"
    },
    "columns": {
      "course": "العنصر",
      "group": "القسم",
      "semester": "السداسي",
      "teacher": "الأستاذ",
      "progress": "الإدخال",
      "status": "الحالة",
      "matricule": "المعرّف",
      "name": "الاسم واللقب",
      "average": "المعدل"
    },
    "filters": {
      "level": "المستوى"
    },
    "savedAt": "حُفظ على الساعة {{time}}",
    "saveFailed": "تعذّر الحفظ — ستُعاد المحاولة عند الإدخال التالي",
    "cellLabel": "{{kind}} — {{name}}",
    "absentTip": "غائب — يُحتسب 0",
    "issues": {
      "invalid_zero": "لا توجد قيم غير صالحة · {{empty}} أعداد ناقصة.",
      "invalid_one": "قيمة واحدة غير صالحة يجب تصحيحها · {{empty}} أعداد ناقصة. الإقفال معطّل ما دامت الورقة غير مكتملة.",
      "invalid_two": "قيمتان غير صالحتين يجب تصحيحهما · {{empty}} أعداد ناقصة. الإقفال معطّل ما دامت الورقة غير مكتملة.",
      "invalid_few": "{{count}} قيم غير صالحة يجب تصحيحها · {{empty}} أعداد ناقصة. الإقفال معطّل ما دامت الورقة غير مكتملة.",
      "invalid_many": "{{count}} قيمةً غير صالحة يجب تصحيحها · {{empty}} أعداد ناقصة. الإقفال معطّل ما دامت الورقة غير مكتملة.",
      "invalid_other": "{{count}} قيمة غير صالحة يجب تصحيحها · {{empty}} أعداد ناقصة. الإقفال معطّل ما دامت الورقة غير مكتملة.",
      "empty_zero": "لا توجد أعداد ناقصة.",
      "empty_one": "عدد واحد ناقص. أكمل الورقة أو استورد ملف Excel.",
      "empty_two": "عددان ناقصان. أكمل الورقة أو استورد ملف Excel.",
      "empty_few": "{{count}} أعداد ناقصة. أكمل الورقة أو استورد ملف Excel.",
      "empty_many": "{{count}} عددًا ناقصًا. أكمل الورقة أو استورد ملف Excel.",
      "empty_other": "{{count}} عدد ناقص. أكمل الورقة أو استورد ملف Excel."
    },
    "lock": "إقفال وإحالة",
    "lockedLabel": "مُقفلة",
    "lockTip": "صحّح القيم غير الصالحة وأكمل الورقة",
    "lockTitle": "إقفال وإحالة؟",
    "lockText_zero": "لا توجد أعداد للإحالة.",
    "lockText_one": "سيُحال عدد طالب واحد إلى لجنة المداولات. لن يمكنك تعديله إلا بطلب تصحيح لدى مصلحة الدراسة.",
    "lockText_two": "ستُحال أعداد طالبين إلى لجنة المداولات. لن يمكنك تعديلها إلا بطلب تصحيح لدى مصلحة الدراسة.",
    "lockText_few": "ستُحال أعداد {{count}} طلبة إلى لجنة المداولات. لن يمكنك تعديلها إلا بطلب تصحيح لدى مصلحة الدراسة.",
    "lockText_many": "ستُحال أعداد {{count}} طالبًا إلى لجنة المداولات. لن يمكنك تعديلها إلا بطلب تصحيح لدى مصلحة الدراسة.",
    "lockText_other": "ستُحال أعداد {{count}} طالب إلى لجنة المداولات. لن يمكنك تعديلها إلا بطلب تصحيح لدى مصلحة الدراسة.",
    "lockConfirm": "إقفال",
    "lockedToast": "أُقفلت الأعداد وأُحيلت إلى اللجنة.",
    "lockedBanner": "أُقفلت الأعداد وأُحيلت إلى مصلحة الدراسة يوم {{date}} على الساعة {{time}}. كل تصحيح يمرّ الآن عبر طلب تعديل.",
    "unlock": "فتح الإقفال",
    "unlockedToast": "فُتحت الورقة: يمكن للأستاذ الإدخال من جديد.",
    "errors": {
      "format": "قيمة غير عددية",
      "range": "خارج المجال (0 إلى 20)",
      "decimals": "رقمان عشريان على الأكثر",
      "absentWithValue": "لا يمكن أن يكون للغائب عدد",
      "reason": "السبب قصير جدًا (5 أحرف على الأقل)",
      "lock": "تعذّر تنفيذ العملية، أعد المحاولة.",
      "lockIncomplete": "الورقة غير مكتملة: أكمل كل الأعداد قبل الإقفال.",
      "unlockPv": "تمّ إصدار محضر هذه الدورة: لا يمكن فتح الورقة."
    },
    "stats": {
      "title": "إحصائيات",
      "average": "معدل القسم",
      "max": "أعلى عدد",
      "min": "أدنى عدد",
      "passRate": "نسبة النجاح",
      "histogram": "توزيع المعدلات حسب شرائح من نقطتين"
    },
    "shortcuts": {
      "title": "اختصارات لوحة المفاتيح",
      "cell": "الخانة الموالية",
      "row": "السطر الموالي",
      "enter": "إدخال",
      "absent": "غائب عن الامتحان",
      "accepted": "القيم المقبولة: من 0 إلى 20، برقمين عشريين (فاصلة أو نقطة)."
    },
    "import": {
      "button": "استيراد Excel",
      "title": "استيراد من Excel",
      "pick": "اختيار ملف ‎.xlsx",
      "hint": "اسحب الملف وأفلته أو انقر · الأعمدة: المعرّف، فرض، أشغال، امتحان",
      "detected_zero": "لم يُعثر على أي سطر",
      "detected_one": "سطر واحد",
      "detected_two": "سطران",
      "detected_few": "{{count}} أسطر",
      "detected_many": "{{count}} سطرًا",
      "detected_other": "{{count}} سطر",
      "recognized_zero": "لم يُتعرّف على أي معرّف",
      "recognized_one": "معرّف واحد معروف",
      "recognized_two": "معرّفان معروفان",
      "recognized_few": "{{count}} معرّفات معروفة",
      "recognized_many": "{{count}} معرّفًا معروفًا",
      "recognized_other": "{{count}} معرّف معروف",
      "unknown_zero": "لا توجد معرّفات غير معروفة",
      "unknown_one": "معرّف واحد غير معروف: {{list}}",
      "unknown_two": "معرّفان غير معروفين: {{list}}",
      "unknown_few": "{{count}} معرّفات غير معروفة: {{list}}",
      "unknown_many": "{{count}} معرّفًا غير معروف: {{list}}",
      "unknown_other": "{{count}} معرّف غير معروف: {{list}}",
      "invalid_zero": "لا توجد قيم غير صالحة",
      "invalid_one": "قيمة واحدة غير صالحة تمّ تجاهلها: {{list}}",
      "invalid_two": "قيمتان غير صالحتين تمّ تجاهلهما: {{list}}",
      "invalid_few": "{{count}} قيم غير صالحة تمّ تجاهلها: {{list}}",
      "invalid_many": "{{count}} قيمةً غير صالحة تمّ تجاهلها: {{list}}",
      "invalid_other": "{{count}} قيمة غير صالحة تمّ تجاهلها: {{list}}",
      "cell": "السطر {{row}}، {{column}} = «{{value}}»",
      "fillable_zero": "لا توجد خانات فارغة للملء",
      "fillable_one": "سيتمّ ملء خانة فارغة واحدة",
      "fillable_two": "سيتمّ ملء خانتين فارغتين",
      "fillable_few": "سيتمّ ملء {{count}} خانات فارغة",
      "fillable_many": "سيتمّ ملء {{count}} خانةً فارغة",
      "fillable_other": "سيتمّ ملء {{count}} خانة فارغة",
      "noOverwrite_zero": "لا تُستبدل الأعداد الموجودة.",
      "noOverwrite_one": "لا تُستبدل الأعداد الموجودة (تمّ تجاهل عدد واحد).",
      "noOverwrite_two": "لا تُستبدل الأعداد الموجودة (تمّ تجاهل عددين).",
      "noOverwrite_few": "لا تُستبدل الأعداد الموجودة (تمّ تجاهل {{count}} أعداد).",
      "noOverwrite_many": "لا تُستبدل الأعداد الموجودة (تمّ تجاهل {{count}} عددًا).",
      "noOverwrite_other": "لا تُستبدل الأعداد الموجودة (تمّ تجاهل {{count}} عدد).",
      "template": "تنزيل النموذج",
      "apply": "استيراد",
      "done_zero": "انتهى الاستيراد: لم يُكمل أي عدد.",
      "done_one": "انتهى الاستيراد: أُكمل عدد واحد.",
      "done_two": "انتهى الاستيراد: أُكمل عددان.",
      "done_few": "انتهى الاستيراد: أُكملت {{count}} أعداد.",
      "done_many": "انتهى الاستيراد: أُكمل {{count}} عددًا.",
      "done_other": "انتهى الاستيراد: أُكمل {{count}} عدد.",
      "errors": {
        "file": "ملف غير مقروء: استعمل نموذج ‎.xlsx.",
        "columns": "الأعمدة المنتظرة: المعرّف وعلى الأقل فرض أو أشغال أو امتحان.",
        "size": "الملف كبير جدًا (1 ميغابايت كحدّ أقصى).",
        "locked": "الورقة مُقفلة: لم يعد الاستيراد ممكنًا."
      },
      "analysing": "جارٍ تحليل الملف…"
    },
    "corrections": {
      "request": "طلب تصحيح",
      "title": "طلب تصحيح",
      "text": "الورقة مُقفلة. يُطبَّق التعديل بعد مصادقة مصلحة الدراسة ويُسجَّل في السجل.",
      "assessment": "الاختبار",
      "current": "العدد الحالي",
      "newValue": "العدد الجديد",
      "reason": "السبب",
      "reasonHint": "مثال: خطأ في النقل، إعادة إصلاح الورقة…",
      "send": "إرسال الطلب",
      "sent": "أُرسل طلب التصحيح إلى مصلحة الدراسة.",
      "pendingExists": "يوجد طلب قيد الانتظار لهذا العدد.",
      "error": "تعذّر تنفيذ العملية، أعد المحاولة.",
      "pendingTitle_zero": "لا توجد طلبات تصحيح",
      "pendingTitle_one": "طلب تصحيح واحد قيد الانتظار",
      "pendingTitle_two": "طلبا تصحيح قيد الانتظار",
      "pendingTitle_few": "{{count}} طلبات تصحيح قيد الانتظار",
      "pendingTitle_many": "{{count}} طلبًا قيد الانتظار",
      "pendingTitle_other": "{{count}} طلب تصحيح قيد الانتظار",
      "approve": "مصادقة",
      "reject": "رفض",
      "approved": "تمّت المصادقة على التصحيح وتطبيقه.",
      "rejected": "رُفض التصحيح."
    },
    "eliminated": "مقصى",
    "eliminatedHint": "تجاوز حد الغيابات: المادة غير محرزة في الدورة الرئيسية والدورة الاستدراكية إجبارية",
    "savedOn": "حُفظ في {{date}} على الساعة {{time}}"
  },
  "deliberation": {
    "title": "لجنة {{level}} · السداسي {{n}}",
    "listSubtitle": "لجان المداولات · {{year}}",
    "empty": "لا توجد لجان لهذه السنة",
    "notFound": "اللجنة غير موجودة",
    "sessionLabel": "الدورة",
    "session": {
      "principale": "الدورة الرئيسية",
      "rattrapage": "التدارك"
    },
    "sessionLong": {
      "principale": "الدورة الرئيسية",
      "rattrapage": "دورة التدارك"
    },
    "ueCount_zero": "لا وحدات",
    "ueCount_one": "وحدة واحدة",
    "ueCount_two": "وحدتان",
    "ueCount_few": "{{count}} وحدات",
    "ueCount_many": "{{count}} وحدةً",
    "ueCount_other": "{{count}} وحدة",
    "credits_zero": "0 رصيد",
    "credits_one": "رصيد واحد",
    "credits_two": "رصيدان",
    "credits_few": "{{count}} أرصدة",
    "credits_many": "{{count}} رصيدًا",
    "credits_other": "{{count}} رصيد",
    "cr_zero": "0 ر.",
    "cr_one": "رصيد",
    "cr_two": "رصيدان",
    "cr_few": "{{count}} أرصدة",
    "cr_many": "{{count}} رصيدًا",
    "cr_other": "{{count}} رصيد",
    "rulesLine": "تعويض سداسي إذا كان المعدل ≥ {{min}} ولا وحدة < {{elim}}",
    "rulesLineNoElim": "تعويض سداسي إذا كان المعدل ≥ {{min}}",
    "rulesNoComp": "لا تعويض سداسي",
    "pv": {
      "open": "المحضر غير مُصدر",
      "generated": "تمّ إصدار المحضر",
      "toValidate": "المحضر في انتظار المصادقة",
      "waitingSheets": "الأعداد قيد الإدخال",
      "waitingPrincipale": "بعد الدورة الرئيسية"
    },
    "generatePv": "إصدار المحضر",
    "downloadPv": "تنزيل المحضر",
    "pvRendering": "جارٍ إعداد المحضر…",
    "pvFailed": "تعذّر إعداد المحضر",
    "blockedTip": "يجب إقفال كل الأوراق واكتمال كل النتائج",
    "pendingSheets_zero": "كل الأوراق مُقفلة",
    "pendingSheets_one": "ورقة أعداد واحدة غير مُقفلة",
    "pendingSheets_two": "ورقتا أعداد غير مُقفلتين",
    "pendingSheets_few": "{{count}} أوراق أعداد غير مُقفلة",
    "pendingSheets_many": "{{count}} ورقةً غير مُقفلة",
    "pendingSheets_other": "{{count}} ورقة غير مُقفلة",
    "kpi": {
      "students": "الطلبة",
      "admitted": "الناجحون",
      "rattrapage": "التدارك",
      "ajournes": "الراسبون",
      "passRate": "نسبة النجاح"
    },
    "filters": {
      "admitted": "الناجحون",
      "rattrapage": "التدارك",
      "ajournes": "الراسبون"
    },
    "legend": {
      "compensated": "وحدة بالتعويض",
      "notAcquired": "وحدة غير مكتسبة"
    },
    "columns": {
      "jury": "اللجنة",
      "sheets": "الأوراق المُقفلة",
      "principale": "الدورة الرئيسية",
      "rattrapage": "التدارك",
      "student": "الطالب",
      "average": "المعدل",
      "credits": "الأرصدة",
      "compensation": "التعويض",
      "decision": "القرار"
    },
    "comp": {
      "yes_zero": "نعم",
      "yes_one": "نعم · وحدة واحدة",
      "yes_two": "نعم · وحدتان",
      "yes_few": "نعم · {{count}} وحدات",
      "yes_many": "نعم · {{count}} وحدةً",
      "yes_other": "نعم · {{count}} وحدة",
      "eliminatory": "لا · عدد < {{grade}}",
      "average": "لا · المعدل < {{min}}",
      "disabled": "غير منطبق"
    },
    "incomplete": "أعداد ناقصة",
    "incompleteShort": "ناقص",
    "noStudents": "لا يوجد طلبة لهذه الدورة",
    "decision": {
      "ADMIS": "ناجح",
      "ADMIS_COMPENSATION": "ناجح بالتعويض",
      "RATTRAPAGE": "تدارك",
      "AJOURNE": "راسب"
    },
    "studentsCount_zero": "لا طلبة",
    "studentsCount_one": "طالب واحد",
    "studentsCount_two": "طالبان",
    "studentsCount_few": "{{count}} طلبة",
    "studentsCount_many": "{{count}} طالبًا",
    "studentsCount_other": "{{count}} طالب",
    "pvToast": "تمّ إصدار {{file}} وإرساله إلى أعضاء اللجنة للإمضاء.",
    "pvDialog": {
      "title": "إصدار محضر المداولات",
      "stats": "إدراج الإحصائيات حسب الوحدة",
      "signatures": "الإمضاء الإلكتروني لأعضاء اللجنة",
      "publish": "نشر النتائج في فضاء الطالب",
      "members": "أعضاء اللجنة",
      "president": "{{name}} (رئاسة اللجنة)",
      "freeze": "ستُثبَّت القرارات: لن يمكن بعدها تعديل أي عدد أو قرار في هذه الدورة.",
      "generate": "إصدار",
      "generating": "جارٍ الإصدار…"
    },
    "override": {
      "button": "تعديل القرار",
      "title": "قرار اللجنة",
      "computed": "القرار المحتسب: {{decision}}",
      "decision": "القرار المعتمد",
      "none": "القرار المحتسب (دون تعديل)",
      "reason": "السبب",
      "reasonHint": "إجباري، يُسجَّل في سجل التدقيق.",
      "saved": "تمّ تسجيل قرار اللجنة.",
      "badge": "قرار عدّلته اللجنة",
      "tip": "قرار عدّلته اللجنة: {{reason}}"
    },
    "rattrapage": {
      "waitTitle": "لم تتمّ مداولات الدورة الرئيسية",
      "waitText": "أصدر أولًا محضر الدورة الرئيسية: هو الذي يحدّد قائمة المدعوّين إلى التدارك.",
      "prepareTitle": "أوراق التدارك في انتظار الإعداد",
      "prepareText_zero": "لا يوجد طلبة مدعوّون.",
      "prepareText_one": "طالب واحد مدعوّ: أنشئ أوراق أعداد العناصر المعنية.",
      "prepareText_two": "طالبان مدعوّان: أنشئ أوراق أعداد العناصر المعنية.",
      "prepareText_few": "{{count}} طلبة مدعوّون: أنشئ أوراق أعداد العناصر المعنية.",
      "prepareText_many": "{{count}} طالبًا مدعوًّا: أنشئ أوراق أعداد العناصر المعنية.",
      "prepareText_other": "{{count}} طالب مدعوّ: أنشئ أوراق أعداد العناصر المعنية.",
      "prepare": "إعداد الأوراق",
      "prepared": "أُنشئت {{sheets}} ورقة تدارك لـ {{students}} طالب."
    },
    "errors": {
      "blocked": "تعذّر الإصدار: بعض الأوراق غير مُقفلة أو بعض النتائج ناقصة.",
      "generic": "تعذّر تنفيذ العملية، أعد المحاولة.",
      "reason": "السبب قصير جدًا (5 أحرف على الأقل)"
    }
  },
  "documents": {
    "listSubtitle": "كشوف الأعداد والشهادات والمحاضر الصادرة، قابلة للتحقق برمز QR",
    "newTranscript": "كشف أعداد جديد",
    "search": "الاسم أو المعرّف أو الرمز",
    "count_zero": "لا وثائق",
    "count_one": "وثيقة واحدة",
    "count_two": "وثيقتان",
    "count_few": "{{n}} وثائق",
    "count_many": "{{n}} وثيقةً",
    "count_other": "{{n}} وثيقة",
    "empty": "لا توجد وثائق صادرة",
    "emptyText": "تظهر هنا كشوف الأعداد والشهادات الصادرة من ملف الطالب.",
    "emptyFiltered": "لا توجد وثيقة مطابقة للمرشّحات",
    "code": "رمز التحقق",
    "download": "تنزيل",
    "downloadNamed": "تنزيل {{file}}",
    "downloaded": "تمّ تنزيل {{file}} (ممضى إلكترونيًا).",
    "generating": "جارٍ الإعداد…",
    "sent": "أُرسلت الوثيقة بالبريد ونُشرت في فضاء الطالب.",
    "verifyOnline": "التحقق عبر الإنترنت",
    "certificateDone": "تمّ إصدار شهادة الترسيم {{year}}.",
    "recordEmpty": "لا توجد وثائق صادرة لهذا الطالب",
    "recordEmptyText": "أصدر شهادة ترسيم أو كشف أعداد من رأس الملف.",
    "types": {
      "RELEVE": "كشف الأعداد",
      "ATTESTATION_INSCRIPTION": "شهادة ترسيم",
      "PV": "محضر المداولات",
      "RECU": "وصل خلاص",
      "CONVENTION_STAGE": "اتفاقية تربص"
    },
    "status": {
      "pending": "قيد الإعداد",
      "ready": "صالحة",
      "failed": "فشل",
      "revoked": "ملغاة"
    },
    "columns": {
      "type": "الوثيقة",
      "student": "الطالب",
      "issuedOn": "تاريخ الإصدار",
      "status": "الحالة"
    },
    "meta": {
      "issued": "صدرت في {{date}}",
      "revoked": "أُلغيت في {{date}}"
    },
    "pick": {
      "label": "الطالب (الاسم أو المعرّف)",
      "hint": "أدخل حرفين على الأقل",
      "none": "لم يُعثر على أي طالب"
    },
    "revoke": {
      "button": "إلغاء",
      "named": "إلغاء الوثيقة {{code}}",
      "title": "إلغاء هذه الوثيقة؟",
      "text": "يبقى الرمز معروفًا في صفحة التحقق لكن يظهر كملغى. هذا الإجراء نهائي ومسجَّل.",
      "reason": "سبب الإلغاء",
      "reasonHint": "إجباري (5 أحرف على الأقل)، يُسجَّل في سجل التدقيق.",
      "confirm": "إلغاء الوثيقة",
      "done": "أُلغيت الوثيقة."
    },
    "transcript": {
      "title": "كشف الأعداد",
      "subtitle": "معاينة A4 · وثيقة رسمية ممضاة إلكترونيًا",
      "send": "إرسال إلى الطالب",
      "send_F": "إرسال إلى الطالبة",
      "send_M": "إرسال إلى الطالب",
      "print": "طباعة",
      "download": "تنزيل PDF",
      "options": "الخيارات",
      "semester": "السداسي",
      "semesterN": "السداسي {{n}}",
      "semesterOption": "السداسي {{n}} · {{level}} · {{year}}",
      "qr": "رمز QR للتحقق",
      "courses": "إظهار العناصر",
      "notIssued": "غير صادر — يُسند الرمز عند أول تنزيل أو إرسال.",
      "previewTitle": "معاينة كشف الأعداد",
      "emptyTitle": "لا يوجد سداسي تمّت مداولته",
      "emptyText": "لا يمكن إصدار كشف رسمي إلا بعد إصدار محضر اللجنة."
    },
    "errors": {
      "generic": "تعذّر تنفيذ العملية، أعد المحاولة.",
      "notDeliberated": "لم تتداول اللجنة هذا السداسي بعد.",
      "noEmail": "لا يوجد بريد إلكتروني في ملف الطالب.",
      "withdrawn": "ترسيم منقطع: لا يمكن إصدار شهادة.",
      "reason": "السبب قصير جدًا (5 أحرف على الأقل)"
    },
    "requests": {
      "title_zero": "لا طلبات",
      "title_one": "طلب واحد من الطلبة",
      "title_two": "طلبان من الطلبة",
      "title_few": "{{count}} طلبات من الطلبة",
      "title_many": "{{count}} طلبًا من الطلبة",
      "title_other": "{{count}} طلب من الطلبة",
      "open": "فتح الملف",
      "done": "تمت المعالجة",
      "reject": "رفض",
      "doneTitle": "إغلاق الطلب كمعالَج؟",
      "rejectTitle": "رفض الطلب؟",
      "answer": "رسالة إلى الطالب (اختياري)",
      "answerDone": "مثال: تُسحب من شباك إدارة الدراسة.",
      "answerRejected": "مثال: الوثيقة غير متاحة لمستواك.",
      "doneToast": "تمت معالجة الطلب وإعلام الطالب.",
      "rejectedToast": "تم رفض الطلب وإعلام الطالب.",
      "failed": "تعذّر تنفيذ العملية. أعد تحميل الصفحة."
    }
  },
  "verify": {
    "title": "التحقق من وثيقة",
    "intro": "أدخل الرمز المطبوع تحت رمز QR لكشف أعداد أو شهادة أو شهادة علمية صادرة عن المؤسسة.",
    "code": "رمز التحقق",
    "submit": "تحقّق",
    "valid": "وثيقة أصلية",
    "validText": "صادرة عن المؤسسة وغير ملغاة إلى اليوم.",
    "revoked": "وثيقة ملغاة",
    "revokedText": "ألغت المؤسسة هذه الوثيقة في {{date}} ولم تعد صالحة.",
    "notFound": "لا توجد وثيقة مطابقة",
    "notFoundText": "تحقّق من الرمز المُدخل. إذا تواصل المشكل، اتصل بمصلحة الدراسة على الرقم {{phone}}.",
    "notFoundTextNoPhone": "تحقّق من الرمز المُدخل. إذا تواصل المشكل، اتصل بمصلحة الدراسة.",
    "limited": "عدد كبير من عمليات التحقق في وقت قصير. أعد المحاولة بعد دقيقة.",
    "notice": "يجب أن تطابق المعلومات المعروضة الوثيقة المقدَّمة تمامًا. لأسباب تتعلق بالسرية، الاسم مخفي جزئيًا.",
    "issuedBy": "{{date}} · أمضاها {{name}}",
    "fields": {
      "type": "النوع",
      "holder": "صاحب الوثيقة",
      "matricule": "المعرّف",
      "program": "التكوين",
      "period": "الفترة",
      "issuedOn": "تاريخ الإصدار",
      "receipt": "عدد الوصل",
      "amount": "المبلغ"
    }
  },
  "admissions": {
    "title": "التسجيل المسبق {{year}}",
    "stepOf": "الخطوة {{n}} من {{total}} · {{name}}",
    "progress": "تقدّم الاستمارة",
    "draft": "مسودة",
    "draftError": "غير متصل — إعادة المحاولة",
    "continue": "متابعة",
    "submit": "إرسال الملف",
    "sending": "جارٍ الإرسال…",
    "closedTitle": "التسجيل المسبق مغلق",
    "closedText": "التسجيل المسبق عبر الإنترنت في {{name}} غير مفتوح حاليًا.",
    "steps": {
      "program": "التكوين",
      "identity": "الهوية",
      "school": "المسار",
      "pieces": "الوثائق",
      "recap": "الملخص",
      "programTitle": "اختر تكوينك",
      "identityTitle": "هويتك",
      "schoolTitle": "المسار الدراسي",
      "piecesTitle": "الوثائق المطلوبة"
    },
    "programDesc_zero": "{{cycle}}",
    "programDesc_one": "{{cycle}} · سنة واحدة",
    "programDesc_two": "{{cycle}} · سنتان",
    "programDesc_few": "{{cycle}} · {{count}} سنوات",
    "programDesc_many": "{{cycle}} · {{count}} سنة",
    "programDesc_other": "{{cycle}} · {{count}} سنة",
    "programMeta": "طاقة الاستيعاب {{capacity}} · {{sections}}",
    "fields": {
      "lastName": "اللقب",
      "firstName": "الاسم",
      "cin": "رقم بطاقة التعريف",
      "birthDate": "تاريخ الولادة",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "bacSection": "شعبة الباكالوريا",
      "bacSession": "الدورة",
      "bacAverage": "المعدل /20",
      "highSchool": "المعهد الأصلي"
    },
    "bacSession": {
      "principale": "الرئيسية {{year}}",
      "controle": "المراقبة {{year}}"
    },
    "sections": {
      "0": "رياضيات",
      "1": "علوم تجريبية",
      "2": "علوم تقنية",
      "3": "علوم الإعلامية",
      "4": "اقتصاد وتصرف",
      "5": "آداب",
      "6": "رياضة"
    },
    "sectionsShort": {
      "0": "رياضيات",
      "1": "علوم تجريبية",
      "2": "علوم تقنية",
      "3": "إعلامية",
      "4": "اقتصاد",
      "5": "آداب",
      "6": "رياضة"
    },
    "sectionDirect": "شعبة {{section}} تخوّل الالتحاق مباشرة بالتكوين المختار.",
    "sectionCommission": "شعبة {{section}} ليست ذات أولوية لهذا التكوين: ستدرس اللجنة ملفك.",
    "pieces": {
      "hint": "PDF أو JPG أو PNG · 5 ميغابايت كحدّ أقصى لكل ملف. يمكنك تصوير وثائقك.",
      "kinds": {
        "cin": "نسخة من بطاقة التعريف (الوجهان)",
        "bac_transcript": "كشف أعداد الباكالوريا",
        "bac_certificate": "شهادة النجاح",
        "photo": "صورة شمسية",
        "fee_receipt": "وصل معاليم الملف"
      },
      "none": "لم يُودَع",
      "uploading": "جارٍ الإرسال…",
      "sent": "أُرسل · {{size}}",
      "verified": "تحقّقت منه مصلحة الدراسة",
      "rejected": "يجب إيداعه من جديد: {{reason}}",
      "tooLargeSize": "الملف كبير جدًا ({{size}}) — 5 ميغابايت كحدّ أقصى.",
      "add": "إضافة",
      "remove": "حذف",
      "retry": "إعادة المحاولة",
      "replace": "تعويض",
      "errors": {
        "too_large": "الملف كبير جدًا — 5 ميغابايت كحدّ أقصى.",
        "type": "صيغة غير مقبولة (PDF أو JPG أو PNG).",
        "network": "انقطع الاتصال.",
        "other": "تعذّر الإرسال، أعد المحاولة."
      },
      "open": "فتح: {{name}}",
      "openFailed": "تعذّر فتح الوثيقة. أعد المحاولة بعد لحظات."
    },
    "size": {
      "kb": "{{n}} ك.ب",
      "mb": "{{n}} م.ب"
    },
    "recap": {
      "choice": "الاختيار",
      "level": "المستوى",
      "firstYear": "السنة الأولى · {{year}}",
      "name": "الاسم",
      "schoolAndPieces": "المسار والوثائق",
      "bac": "الباكالوريا",
      "pieces": "الوثائق",
      "piecesCount": "{{n}} / {{total}} مودعة"
    },
    "consent": "أشهد بصحة المعلومات المقدّمة وأقبل النظام الداخلي للمؤسسة.",
    "fee": "معاليم الملف",
    "feeHint": "تُدفع بتحويل بنكي أو بالشبّاك؛ أرفق الوصل ضمن الوثائق.",
    "sent": {
      "title": "تمّ إرسال الملف",
      "text": "أُرسل بريد تأكيد إلى {{email}}.",
      "tracking": "رقم المتابعة",
      "code": "رمز الدخول",
      "keep": "احتفظ بهذين العنصرين: يمكّنانك من متابعة ملفك.",
      "follow": "متابعة ملفي"
    },
    "track": {
      "title": "متابعة ملفك",
      "intro": "أدخل رقم المتابعة ورمز الدخول الذي وصلك بالبريد.",
      "tracking": "رقم المتابعة",
      "code": "رمز الدخول",
      "codeHint": "8 رموز، أُرسل مع تأكيد الإيداع.",
      "submit": "عرض",
      "notFound": "الملف غير موجود",
      "notFoundText": "تحقّق من رقم المتابعة ورمز الدخول.",
      "follow": "متابعة ملفك",
      "filed": "تمّ إيداع الملف",
      "feePaid": "تمّ خلاص معاليم الملف",
      "feeCheck": "معاليم الملف",
      "feeCheckText": "الوصل قيد التحقق",
      "review": "الدراسة من طرف اللجنة",
      "reviewText_zero": "الرد خلال أيام عمل",
      "reviewText_one": "الرد خلال يوم عمل واحد",
      "reviewText_two": "الرد خلال يومي عمل",
      "reviewText_few": "الرد خلال {{count}} أيام عمل",
      "reviewText_many": "الرد خلال {{count}} يوم عمل",
      "reviewText_other": "الرد خلال {{count}} يوم عمل",
      "interview": "مقابلة القبول",
      "decision": "القرار والتسجيل",
      "decisionText": "سيتمّ إعلامك بالبريد الإلكتروني",
      "accepted": "تمّ قبول الترشح",
      "acceptedText": "ستتصل بك مصلحة الدراسة من أجل التسجيل.",
      "refused": "لم يتمّ قبول الترشح",
      "refusedText": "يمكنك الاتصال بمصلحة الدراسة.",
      "missing_zero": "لا وثائق ناقصة.",
      "missing_one": "وثيقة واحدة يجب إيداعها أو تعويضها.",
      "missing_two": "وثيقتان يجب إيداعهما أو تعويضهما.",
      "missing_few": "{{count}} وثائق يجب إيداعها أو تعويضها.",
      "missing_many": "{{count}} وثيقة يجب إيداعها أو تعويضها.",
      "missing_other": "{{count}} وثيقة يجب إيداعها أو تعويضها.",
      "trackingFormat": "الصيغة المنتظرة: PRE-2026-0412.",
      "codeFormat": "يتكوّن رمز النفاذ من 8 أحرف.",
      "showCode": "إظهار الرمز",
      "hideCode": "إخفاء الرمز"
    },
    "candidate": {
      "empty": "لا يوجد ملف تسجيل مسبق",
      "emptyText": "أودع ترشحك عبر الإنترنت في دقائق.",
      "apply": "بدء التسجيل المسبق",
      "uploadHint": "لإيداع وثيقة، استعمل صفحة المتابعة برقمك ورمز الدخول."
    },
    "status": {
      "draft": "مسودة",
      "submitted": "جديد",
      "review": "قيد الدراسة",
      "interview": "مقابلة",
      "accepted": "مقبول",
      "refused": "مرفوض"
    },
    "tabs": {
      "all": "الكل",
      "submitted": "الجديدة",
      "review": "قيد الدراسة",
      "interview": "مقابلة",
      "accepted": "المقبولة",
      "refused": "المرفوضة"
    },
    "columns": {
      "tracking": "رقم الملف",
      "candidate": "المترشح",
      "program": "التكوين المطلوب",
      "bac": "الباكالوريا · المعدل",
      "filedOn": "تاريخ الإيداع",
      "pieces": "الوثائق",
      "status": "الحالة"
    },
    "staff": {
      "title": "الترشحات {{year}}",
      "subtitle": "ادرس الملفات المودعة عبر الإنترنت وقرّر القبول.",
      "publicForm": "عرض الاستمارة العمومية",
      "search": "الاسم أو بطاقة التعريف أو رقم الملف",
      "allPrograms": "كل التكوينات",
      "since": "مودعة منذ",
      "selection_zero": "لم يتمّ اختيار أي ترشح",
      "selection_one": "تمّ اختيار ترشح واحد",
      "selection_two": "تمّ اختيار ترشحين",
      "selection_few": "تمّ اختيار {{count}} ترشحات",
      "selection_many": "تمّ اختيار {{count}} ترشحًا",
      "selection_other": "تمّ اختيار {{count}} ترشح",
      "empty": "لا توجد ترشحات لهذه المرشّحات",
      "emptyText": "غيّر المعايير أو أعد ضبط البحث لعرض كل الترشحات.",
      "resetFilters": "إعادة ضبط المرشّحات",
      "noneYet": "لم تصل أي ترشّحات بعد",
      "noneYetText": "ستظهر هنا الملفات المودعة عبر استمارة التسجيل المسبق العمومية."
    },
    "actions": {
      "accept": "قبول",
      "interview": "استدعاء لمقابلة",
      "convoke": "استدعاء",
      "refuse": "رفض",
      "reopen": "إعادة فتح الملف"
    },
    "bulk": {
      "title": {
        "accept_zero": "قبول الترشحات؟",
        "accept_one": "قبول هذا الترشح؟",
        "accept_two": "قبول الترشحين؟",
        "accept_few": "قبول {{count}} ترشحات؟",
        "accept_many": "قبول {{count}} ترشحًا؟",
        "accept_other": "قبول {{count}} ترشح؟",
        "interview_zero": "استدعاء لمقابلة",
        "interview_one": "استدعاء مترشح لمقابلة",
        "interview_two": "استدعاء مترشحين لمقابلة",
        "interview_few": "استدعاء {{count}} مترشحين لمقابلة",
        "interview_many": "استدعاء {{count}} مترشحًا لمقابلة",
        "interview_other": "استدعاء {{count}} مترشح لمقابلة",
        "refuse_zero": "رفض الترشحات؟",
        "refuse_one": "رفض هذا الترشح؟",
        "refuse_two": "رفض الترشحين؟",
        "refuse_few": "رفض {{count}} ترشحات؟",
        "refuse_many": "رفض {{count}} ترشحًا؟",
        "refuse_other": "رفض {{count}} ترشح؟",
        "review_zero": "إعادة فتح الملفات؟",
        "review_one": "إعادة فتح هذا الملف؟",
        "review_two": "إعادة فتح الملفين؟",
        "review_few": "إعادة فتح {{count}} ملفات؟",
        "review_many": "إعادة فتح {{count}} ملفًا؟",
        "review_other": "إعادة فتح {{count}} ملف؟"
      },
      "text": {
        "accept": "سيتمّ إعلام المترشحين بالبريد. يمكنك بعدها إنشاء ملفاتهم الطلابية.",
        "interview": "يُرسل استدعاء بالبريد مع التاريخ والساعة.",
        "refuse": "سيتمّ إعلام المترشحين بالبريد. يمكنك إعادة فتح ملف من سجله.",
        "review": "يعود الملف إلى «قيد الدراسة»؛ لا يُعلَم المترشح."
      },
      "confirm": {
        "accept": "قبول",
        "interview": "إرسال الاستدعاء",
        "refuse": "رفض",
        "review": "إعادة الفتح"
      },
      "done": {
        "accept_zero": "لم يُقبل أي ترشح.",
        "accept_one": "قُبل ترشح واحد — أُرسل بريد القبول.",
        "accept_two": "قُبل ترشحان — أُرسلت رسائل القبول.",
        "accept_few": "قُبلت {{count}} ترشحات — أُرسلت رسائل القبول.",
        "accept_many": "قُبل {{count}} ترشحًا — أُرسلت رسائل القبول.",
        "accept_other": "قُبل {{count}} ترشح — أُرسلت رسائل القبول.",
        "interview_zero": "لم يُرسل أي استدعاء.",
        "interview_one": "أُرسل استدعاء واحد ليوم {{date}}.",
        "interview_two": "أُرسل استدعاءان ليوم {{date}}.",
        "interview_few": "أُرسلت {{count}} استدعاءات ليوم {{date}}.",
        "interview_many": "أُرسل {{count}} استدعاءً ليوم {{date}}.",
        "interview_other": "أُرسل {{count}} استدعاء ليوم {{date}}.",
        "refuse_zero": "لم يُرفض أي ترشح.",
        "refuse_one": "رُفض ترشح واحد.",
        "refuse_two": "رُفض ترشحان.",
        "refuse_few": "رُفضت {{count}} ترشحات.",
        "refuse_many": "رُفض {{count}} ترشحًا.",
        "refuse_other": "رُفض {{count}} ترشح.",
        "review_zero": "لم يُعد فتح أي ملف.",
        "review_one": "أُعيد فتح ملف واحد.",
        "review_two": "أُعيد فتح ملفين.",
        "review_few": "أُعيد فتح {{count}} ملفات.",
        "review_many": "أُعيد فتح {{count}} ملفًا.",
        "review_other": "أُعيد فتح {{count}} ملف."
      },
      "skipped_zero": "لا ملفات متجاهلة.",
      "skipped_one": "تمّ تجاهل ملف واحد (حالة غير متوافقة).",
      "skipped_two": "تمّ تجاهل ملفين (حالة غير متوافقة).",
      "skipped_few": "تمّ تجاهل {{count}} ملفات (حالة غير متوافقة).",
      "skipped_many": "تمّ تجاهل {{count}} ملفًا (حالة غير متوافقة).",
      "skipped_other": "تمّ تجاهل {{count}} ملف (حالة غير متوافقة).",
      "reason": "السبب المبلَّغ للمترشح (اختياري)",
      "reasonPlaceholder": "مثال: بلوغ طاقة الاستيعاب لهذا التكوين.",
      "when": "تاريخ وساعة المقابلة"
    },
    "sheet": {
      "label": "تفاصيل الترشح",
      "program": "التكوين المطلوب",
      "firstYear": "السنة الأولى · العودة الجامعية {{year}}",
      "interviewOn": "المقابلة يوم {{date}} على الساعة {{time}}",
      "refusedReason": "السبب: {{reason}}",
      "bac": "الباكالوريا",
      "bacAverage": "معدل الباكالوريا",
      "pieceMeta": "{{size}} · أُودعت في {{date}}",
      "preview": "معاينة",
      "previewNamed": "معاينة: {{piece}}",
      "verify": "المصادقة على الوثيقة",
      "verifyNamed": "المصادقة: {{piece}}",
      "reject": "رفض",
      "rejectNamed": "رفض: {{piece}}",
      "rejectTitle": "رفض «{{piece}}»؟",
      "rejectText": "يُعلَم المترشح بالبريد ويمكنه إيداع وثيقة جديدة من صفحة المتابعة.",
      "rejectReason": "السبب (يُرسل إلى المترشح)",
      "rejectPlaceholder": "مثال: وثيقة غير مقروءة، الوجه الخلفي ناقص.",
      "pieceVerified": "تمّت المصادقة على الوثيقة.",
      "pieceRejected": "رُفضت الوثيقة — تمّ إعلام المترشح.",
      "history": "السجل",
      "convert": "إنشاء الملف الطلابي",
      "converted": "تمّ إنشاء الملف الطلابي (المعرّف {{matricule}}).",
      "openRecord": "فتح الملف الطلابي"
    },
    "pieceStatus": {
      "missing": "ناقصة",
      "uploaded": "للتحقق",
      "verified": "مُتحقَّق منها",
      "rejected": "مرفوضة"
    },
    "mentions": {
      "tres_bien": "حسن جدًا",
      "bien": "حسن",
      "assez_bien": "قريب من الحسن",
      "passable": "متوسط"
    },
    "history": {
      "submit": "أُودع الملف عبر الإنترنت",
      "status": "الحالة: {{status}}",
      "piece_verify": "تمّت المصادقة على الوثيقة: {{piece}}",
      "piece_reject": "رُفضت الوثيقة: {{piece}} — {{reason}}",
      "piece_upload": "أُعيد إيداع الوثيقة: {{piece}}",
      "convert": "أُنشئ الملف الطلابي ({{matricule}})"
    },
    "overview": {
      "title": "التسجيل المسبق {{year}}",
      "subtitle": "حملة التسجيل المسبق عبر الإنترنت: الرابط العمومي والملفات وطاقة الاستيعاب.",
      "open": "مفتوحة",
      "closed": "مغلقة",
      "copy": "نسخ الرابط العمومي",
      "copied": "تمّ نسخ الرابط.",
      "filed": "الملفات المودعة",
      "toReview": "للدراسة",
      "drafts": "مسودات جارية",
      "draftsNote": "استمارات بدأت ولم تُرسل",
      "intake": "طاقة الاستيعاب حسب التكوين",
      "intakeOf": "المقبولون في {{name}}",
      "intakeLine": "{{accepted}} مقبول / {{capacity}} مقعد · {{filed}} ملف",
      "publicLink": "رابط الاستمارة العمومية"
    },
    "errors": {
      "required": "حقل إجباري.",
      "cin": "يجب أن يتكوّن رقم بطاقة التعريف من 8 أرقام.",
      "email": "بريد إلكتروني غير صالح.",
      "phone": "رقم هاتف غير صالح.",
      "birthDate": "تاريخ الولادة إجباري.",
      "average": "معدل بين 0 و20.",
      "program": "اختر تكوينًا.",
      "tracking": "رقم متابعة غير صالح (مثال PRE-2026-0412).",
      "interviewAt": "حدّد تاريخ المقابلة.",
      "reason": "السبب قصير جدًا.",
      "consent": "ضع علامة للتأكيد.",
      "missingPieces": "أودع كل الوثائق المطلوبة.",
      "duplicate": "يوجد ملف لهذا الرقم هذه السنة.",
      "submit": "تعذّر الإرسال، أعد المحاولة.",
      "action": "تعذّر تنفيذ العملية، أعد المحاولة."
    },
    "listSeparator": "، "
  },
  "finance": {
    "title": "معاليم الدراسة",
    "subtitle_zero": "{{year}} · معاليم الدراسة: {{total}} – {{count}} قسط",
    "subtitle_one": "{{year}} · معاليم الدراسة: {{total}} – قسط واحد",
    "subtitle_two": "{{year}} · معاليم الدراسة: {{total}} – قسطان",
    "subtitle_few": "{{year}} · معاليم الدراسة: {{total}} – {{count}} أقساط",
    "subtitle_many": "{{year}} · معاليم الدراسة: {{total}} – {{count}} قسطًا",
    "subtitle_other": "{{year}} · معاليم الدراسة: {{total}} – {{count}} قسط",
    "tabs": {
      "schedules": "جداول الخلاص",
      "unpaid": "المتخلّدات",
      "schedulesLong": "جدول خلاص الطالب",
      "unpaidLong": "المتخلّدات والتذكيرات"
    },
    "pickStudent": "البحث عن طالب (الاسم، المعرّف، بطاقة التعريف)",
    "guardian": "الولي: {{name}}، {{phone}}",
    "openRecord": "عرض الملف",
    "otherStudent": "طالب آخر",
    "chequeNo": "عدد {{n}}",
    "status": {
      "paid": "خالص",
      "late": "غير خالص",
      "todo": "قادم",
      "pending": "صك في الانتظار"
    },
    "paymentStatus": {
      "cleared": "مقبوض",
      "pending": "صك في الانتظار",
      "rejected": "صك مرفوض",
      "cancelled": "ملغى"
    },
    "methods": {
      "cash": "نقدًا",
      "cheque": "صك",
      "transfer": "تحويل",
      "online": "عبر الإنترنت"
    },
    "channels": {
      "email": "بريد إلكتروني",
      "sms": "إرسالية قصيرة",
      "whatsapp": "واتساب"
    },
    "account": {
      "total": "المجموع {{year}}",
      "paid": "المدفوع",
      "remaining": "الباقي",
      "schedule": "جدول الخلاص",
      "paidPct": "{{pct}} % مدفوع",
      "columns": {
        "installment": "القسط",
        "dueOn": "آخر أجل",
        "amount": "المبلغ",
        "status": "الحالة",
        "detail": "التفاصيل",
        "actions": "إجراءات"
      },
      "lateBy_zero": "متأخر {{count}} يوم",
      "lateBy_one": "متأخر يومًا واحدًا",
      "lateBy_two": "متأخر يومين",
      "lateBy_few": "متأخر {{count}} أيام",
      "lateBy_many": "متأخر {{count}} يومًا",
      "lateBy_other": "متأخر {{count}} يوم",
      "partial": "تم دفع {{paid}}",
      "pendingInfo": "{{mode}} · في طور الاستخلاص",
      "noInstallments": "لا يوجد جدول خلاص لهذه السنة",
      "notEnrolled": "غير مرسّم هذه السنة",
      "canGenerateText": "لم يطبَّق بعد جدول معاليم السنة على هذا الترسيم.",
      "noScheduleText": "لا يوجد جدول معاليم لهذا المسلك وهذه السنة.",
      "generate": "إنشاء جدول الخلاص"
    },
    "actions": {
      "collect": "استخلاص",
      "collectOf": "استخلاص · {{label}}",
      "receipt": "وصل",
      "cancel": "إلغاء الدفع",
      "cancelOf": "إلغاء دفع {{label}}",
      "clear": "تم استخلاص الصك",
      "reject": "مرفوض"
    },
    "pay": {
      "title": "استخلاص · {{label}}",
      "due": "الباقي {{due}}",
      "amount": "المبلغ (د.ت)",
      "mode": "طريقة الدفع",
      "invalidAmount": "أدخل مبلغًا صحيحًا.",
      "overDue": "المبلغ يتجاوز الباقي ({{due}}).",
      "chequeNumber": "عدد الصك",
      "bank": "البنك",
      "reference": "المرجع",
      "valueDate": "تاريخ القيمة",
      "cashBy": "قبضه {{name}} · الخزينة الرئيسية · {{date}}",
      "chequeHint": "يبقى الصك «في الانتظار» إلى حين استخلاصه، ويُصدر الوصل عندها.",
      "submit": "تسجيل الدفع"
    },
    "receipt": {
      "title": "تم تسجيل الدفع",
      "number": "وصل",
      "student": "الطالب",
      "installment": "القسط",
      "mode": "الطريقة",
      "date": "التاريخ",
      "amount": "المبلغ",
      "print": "طباعة",
      "send": "إرسال بالبريد"
    },
    "cancel": {
      "title": "إلغاء هذا الدفع؟",
      "text": "سيُلغى دفع {{amount}} ({{label}}) ويُبطل وصله؛ ويعود القسط «غير خالص» إن حلّ أجله. يُسجَّل هذا الإجراء في السجل.",
      "confirm": "إلغاء الدفع",
      "keep": "الإبقاء"
    },
    "toast": {
      "cleared": "{{label}}: تم استخلاص الصك.",
      "rejected": "{{label}}: رُفض الصك — عاد القسط غير خالص.",
      "cancelled": "أُلغي دفع {{label}}.",
      "chequePending": "سُجّل الصك لـ{{label}} — في انتظار الاستخلاص.",
      "receiptSent": "أُرسل الوصل بالبريد."
    },
    "errors": {
      "generic": "فشلت العملية. أعد المحاولة.",
      "receipt": "تعذّر إنشاء الوصل. أعد المحاولة.",
      "noEmail": "ليس للطالب بريد إلكتروني.",
      "trancheOrder": "يجب أن تكون الآجال حسب ترتيب الأقساط.",
      "chequeNumber": "أدخل عدد الصك.",
      "bank": "اختر البنك.",
      "reference": "أدخل مرجع التحويل."
    },
    "journal": {
      "title": "آخر المقبوضات",
      "pendingCheques": "صكوك في الانتظار",
      "date": "التاريخ",
      "student": "الطالب",
      "installment": "القسط",
      "mode": "الطريقة",
      "amount": "المبلغ",
      "status": "الحالة",
      "receipt": "الوصل",
      "empty": "لا توجد دفوعات",
      "emptyText": "ستظهر مقبوضات السنة هنا."
    },
    "schedule": {
      "open": "جدول المعاليم",
      "title": "جدول المعاليم · {{year}}",
      "text": "أقساط تطبَّق على الترسيمات الجديدة للسنة. لا تُغيَّر الجداول الموجودة.",
      "label": "التسمية",
      "note": "توضيح",
      "dueOn": "آخر أجل",
      "amount": "المبلغ (د.ت)",
      "add": "إضافة قسط",
      "remove": "حذف القسط {{label}}",
      "total": "المجموع:",
      "trancheN": "القسط {{n}}",
      "saved": "تم حفظ جدول المعاليم.",
      "missing_zero": "{{count}} ترسيم دون جدول خلاص.",
      "missing_one": "ترسيم واحد دون جدول خلاص.",
      "missing_two": "ترسيمان دون جدول خلاص.",
      "missing_few": "{{count}} ترسيمات دون جدول خلاص.",
      "missing_many": "{{count}} ترسيمًا دون جدول خلاص.",
      "missing_other": "{{count}} ترسيم دون جدول خلاص.",
      "apply": "تطبيق جدول المعاليم",
      "applied_zero": "لم يُنشأ أي جدول.",
      "applied_one": "أُنشئ جدول واحد.",
      "applied_two": "أُنشئ جدولان.",
      "applied_few": "أُنشئت {{count}} جداول.",
      "applied_many": "أُنشئ {{count}} جدولًا.",
      "applied_other": "أُنشئ {{count}} جدول."
    },
    "unpaid": {
      "kpi": {
        "amount": "المبلغ غير المدفوع",
        "students": "الطلبة المعنيّون",
        "avgLate": "متوسط التأخير",
        "recovered": "المستخلص هذا الشهر"
      },
      "columns": {
        "student": "الطالب",
        "program": "المسلك",
        "installment": "القسط",
        "amount": "المبلغ",
        "late": "التأخير",
        "lastReminder": "آخر تذكير",
        "status": "الحالة"
      },
      "days": "{{n}} ي",
      "minDays": "أكثر من {{n}} ي",
      "reminded": "تم التذكير",
      "search": "البحث عن طالب أو معرّف",
      "selected_zero": "لا شيء محدد",
      "selected_one": "عنصر واحد محدد",
      "selected_two": "عنصران محددان",
      "selected_few": "{{count}} عناصر محددة",
      "selected_many": "{{count}} عنصرًا محددًا",
      "selected_other": "{{count}} عنصر محدد",
      "remind": "إرسال تذكير",
      "empty": "لا توجد متخلّدات",
      "emptyText": "كل الأقساط الحالّة خالصة.",
      "emptyFiltered": "لا نتائج",
      "emptyFilteredText": "لا يوجد متخلّد يطابق هذه المرشحات.",
      "shown_zero": "{{count}} متخلّد معروض من {{total}}",
      "shown_one": "{{count}} متخلّد معروض من {{total}}",
      "shown_two": "{{count}} متخلّد معروض من {{total}}",
      "shown_few": "{{count}} متخلّد معروض من {{total}}",
      "shown_many": "{{count}} متخلّد معروض من {{total}}",
      "shown_other": "{{count}} متخلّد معروض من {{total}}"
    },
    "remind": {
      "title_zero": "إرسال تذكير · {{count}} مستلم",
      "title_one": "إرسال تذكير · مستلم واحد",
      "title_two": "إرسال تذكير · مستلمان",
      "title_few": "إرسال تذكير · {{count}} مستلمين",
      "title_many": "إرسال تذكير · {{count}} مستلمًا",
      "title_other": "إرسال تذكير · {{count}} مستلم",
      "channels": "القنوات",
      "preview": "معاينة لـ{{name}}",
      "body": "مرحبًا {{name}}، نذكّرك بأنّ {{installment}} من معاليم الدراسة (الباقي: {{amount}}) كان مستحقًّا بتاريخ {{dueOn}}. يرجى تسوية وضعيتك لدى المصلحة المالية. — {{institution}}",
      "note": "رسالة إضافية (اختياري)",
      "noteHint": "تضاف إلى تذكير كل طالب.",
      "noEmail_zero": "{{count}} طالب دون بريد إلكتروني.",
      "noEmail_one": "طالب واحد دون بريد إلكتروني ولن يتلقى التذكير.",
      "noEmail_two": "طالبان دون بريد إلكتروني ولن يتلقيا التذكير.",
      "noEmail_few": "{{count}} طلبة دون بريد إلكتروني ولن يتلقوا التذكير.",
      "noEmail_many": "{{count}} طالبًا دون بريد إلكتروني ولن يتلقوا التذكير.",
      "noEmail_other": "{{count}} طالب دون بريد إلكتروني ولن يتلقوا التذكير.",
      "send": "إرسال",
      "sent_zero": "لم يُرسل أي تذكير.",
      "sent_one": "أُرسل تذكير واحد.",
      "sent_two": "أُرسل تذكيران.",
      "sent_few": "أُرسلت {{count}} تذكيرات.",
      "sent_many": "أُرسل {{count}} تذكيرًا.",
      "sent_other": "أُرسل {{count}} تذكير.",
      "sentSkipped_zero": "لم يُرسل أي تذكير ({{skipped}} دون بريد).",
      "sentSkipped_one": "أُرسل تذكير واحد ({{skipped}} دون بريد).",
      "sentSkipped_two": "أُرسل تذكيران ({{skipped}} دون بريد).",
      "sentSkipped_few": "أُرسلت {{count}} تذكيرات ({{skipped}} دون بريد).",
      "sentSkipped_many": "أُرسل {{count}} تذكيرًا ({{skipped}} دون بريد).",
      "sentSkipped_other": "أُرسل {{count}} تذكير ({{skipped}} دون بريد)."
    }
  },
  "attendance": {
    "title": "متابعة الغيابات",
    "subtitle": "عتبة الإقصاء: {{pct}} من الغيابات غير المبرّرة من الحجم الساعي للوحدة.",
    "subtitleNoElim": "لا إقصاء؛ تنبيه عند {{alert}} من الغيابات غير المبرّرة من الحجم الساعي للوحدة.",
    "rollCallLink": "مناداة الأستاذ (جوال)",
    "notifyAll": "إشعار الطلبة في حالة تنبيه",
    "listTitle": "الطلبة القريبون من العتبة",
    "thresholdMark": "العتبة {{pct}}",
    "kpi": {
      "hours": "ساعات الغياب (الأسبوع {{week}})",
      "justified": "منها {{hours}} مبرّرة",
      "rate": "نسبة الغياب",
      "delta": "{{delta}} نقطة مقارنة بالأسبوع {{week}}",
      "noPrevious": "لا حصص في الأسبوع السابق",
      "alert": "في حالة تنبيه (≥ {{pct}})",
      "alertNote": "يُنصح بالإشعار",
      "elim": "مقصون (≥ {{pct}})",
      "elimNote": "محرومون من امتحان الوحدة"
    },
    "filters": {
      "all": "الكل",
      "elim": "مقصون",
      "alert": "تنبيه",
      "watch": "تحت المراقبة"
    },
    "levels": {
      "elim": "مقصى",
      "alert": "تنبيه",
      "watch": "تحت المراقبة"
    },
    "columns": {
      "student": "الطالب",
      "group": "الفوج",
      "course": "الوحدة",
      "rate": "الغيابات غير المبرّرة / العتبة",
      "hours": "الساعات",
      "status": "الحالة"
    },
    "actions": {
      "justify": "تبرير",
      "notify": "إشعار",
      "notified": "تم الإشعار"
    },
    "empty": "لا يوجد طالب في هذه الفئة",
    "emptyText": "نسب الغياب تحت العتبات.",
    "kinds": {
      "CM": "درس",
      "TD": "أشغال موجّهة",
      "TP": "أشغال تطبيقية"
    },
    "reasons": {
      "medical": "شهادة طبية",
      "administrative": "استدعاء إداري",
      "bereavement": "وفاة قريب",
      "other": "أخرى (توضيح)"
    },
    "justify": {
      "title": "تبرير غياب",
      "sessions": "الغيابات المعنية",
      "none": "لا يوجد غياب غير مبرّر لهذه الوحدة.",
      "reason": "السبب",
      "note": "توضيح",
      "file": "إرفاق المبرّر",
      "fileHint": "PDF أو JPG أو PNG · 5 م.ب كحد أقصى · اختياري",
      "tooLarge": "يتجاوز الملف 5 م.ب.",
      "submit": "المصادقة على المبرّر",
      "done": "تمت المصادقة على المبرّر: حُذفت {{hours}} لـ{{name}}."
    },
    "toast": {
      "notifiedOne": "تم إشعار {{name}} بالبريد.",
      "notified_zero": "لم يُشعر أي طالب.",
      "notified_one": "تم إشعار طالب واحد.",
      "notified_two": "تم إشعار طالبين.",
      "notified_few": "تم إشعار {{count}} طلبة.",
      "notified_many": "تم إشعار {{count}} طالبًا.",
      "notified_other": "تم إشعار {{count}} طالب."
    },
    "errors": {
      "generic": "فشلت العملية. أعد المحاولة.",
      "endBeforeStart": "يجب أن تكون النهاية بعد البداية.",
      "tooLong": "لا تتجاوز الحصة 6 ساعات."
    },
    "record": {
      "absent": "ساعات الغياب",
      "justified": "منها مبرّرة",
      "late": "التأخيرات",
      "byCourse": "حسب الوحدة",
      "sessions": "الحصص الفائتة",
      "justifications": "المبرّرات",
      "columns": {
        "course": "الوحدة",
        "hours": "غير مبرّرة / الحجم",
        "rate": "النسبة",
        "status": "الحالة"
      },
      "absentMark": "غائب · {{hours}}",
      "justifiedMark": "مبرّر · {{hours}}",
      "empty": "لا غيابات",
      "emptyText": "لا غياب ولا تأخير في {{year}}."
    },
    "pending": {
      "title_zero": "لا مبررات للتثبت",
      "title_one": "مبرر واحد للتثبت",
      "title_two": "مبرران للتثبت",
      "title_few": "{{count}} مبررات للتثبت",
      "title_many": "{{count}} مبررًا للتثبت",
      "title_other": "{{count}} مبرر للتثبت",
      "meta": "{{hours}} · أُرسل في {{date}}",
      "view": "عرض المبرر",
      "approve": "قبول",
      "reject": "رفض",
      "rejectTitle": "رفض مبرر {{name}}؟",
      "reason": "السبب المبلّغ للطالب (اختياري)",
      "approved": "تم قبول المبرر وإعلام الطالب.",
      "rejected": "تم رفض المبرر وإعلام الطالب.",
      "failed": "تعذّر تنفيذ العملية. أعد تحميل الصفحة."
    }
  },
  "rollCall": {
    "homeTitle": "المناداة",
    "homeSubtitle": "حصصك اليوم والحصص التي لم تُسجَّل مناداتها بعد.",
    "today": "اليوم",
    "noToday": "لا حصص اليوم",
    "pending": "مناداة متبقية",
    "pendingHint": "حصص سابقة دون مناداة مسجّلة.",
    "recent": "آخر المناداات",
    "groupLine": "{{level}} الفوج {{group}}",
    "doneChip": "تمّت · {{present}}/{{total}}",
    "todoChip": "متبقية",
    "newSession": "حصة إضافية",
    "newSessionHint": "لحصة خارج جدول الأوقات (تدارك، حصة مؤجلة).",
    "course": "الوحدة والفوج",
    "kind": "النوع",
    "date": "التاريخ",
    "start": "البداية",
    "duration": "المدة",
    "minutes": "{{n}} دق",
    "room": "القاعة",
    "open": "فتح المناداة",
    "title": "المناداة · {{level}} الفوج {{group}}",
    "counters": {
      "present": "حاضرون",
      "absent": "غائبون",
      "late": "متأخرون"
    },
    "marks": {
      "present": "حاضر",
      "absent": "غائب",
      "late": "متأخر"
    },
    "tapHint": "المس طالبًا لتغيير حالته",
    "allPresent": "الكل حاضر",
    "rowLabel": "{{name}}: {{mark}}. المس للتغيير.",
    "validate_zero": "تأكيد المناداة · {{count}} طالب",
    "validate_one": "تأكيد المناداة · طالب واحد",
    "validate_two": "تأكيد المناداة · طالبان",
    "validate_few": "تأكيد المناداة · {{count}} طلبة",
    "validate_many": "تأكيد المناداة · {{count}} طالبًا",
    "validate_other": "تأكيد المناداة · {{count}} طالب",
    "confirmTitle": "تأكيد المناداة؟",
    "confirmText": "سيتلقى الطلبة الغائبون إشعارًا؛ ولهم {{hours}} ساعة لتقديم مبرّر.",
    "confirm": "تأكيد",
    "backToRoster": "العودة إلى القائمة",
    "summary": "{{present}}، {{absent}}، {{late}}.",
    "presentN_zero": "{{count}} حاضر",
    "presentN_one": "حاضر واحد",
    "presentN_two": "حاضران",
    "presentN_few": "{{count}} حاضرين",
    "presentN_many": "{{count}} حاضرًا",
    "presentN_other": "{{count}} حاضر",
    "absentN_zero": "{{count}} غائب",
    "absentN_one": "غائب واحد",
    "absentN_two": "غائبان",
    "absentN_few": "{{count}} غائبين",
    "absentN_many": "{{count}} غائبًا",
    "absentN_other": "{{count}} غائب",
    "lateN_zero": "{{count}} متأخر",
    "lateN_one": "متأخر واحد",
    "lateN_two": "متأخران",
    "lateN_few": "{{count}} متأخرين",
    "lateN_many": "{{count}} متأخرًا",
    "lateN_other": "{{count}} متأخر",
    "saved": "تم تسجيل المناداة",
    "savedAt": "سُجّلت يوم {{date}} على الساعة {{time}}.",
    "edit": "تعديل المناداة",
    "backToList": "حصصي",
    "alreadyDone": "سُجّلت المناداة يوم {{date}} على الساعة {{time}} — يمكنك تصحيحها.",
    "closed": "لم يعد بالإمكان تعديل هذه المناداة.",
    "offline": "دون اتصال: حُفظت المناداة على هذا الهاتف وستُرسل تلقائيًا.",
    "retrying": "تعذّر الإرسال حاليًا: حُفظت المناداة على هذا الهاتف وستُعاد محاولة إرسالها تلقائيًا.",
    "notFound": "هذه الحصة غير موجودة أو غير مسندة إليك.",
    "teacherAbsent": "الأستاذ غائب: لم تُنجز الحصة، ولا يوجد تسجيل حضور."
  },
  "timetable": {
    "title": "جدول الأوقات",
    "subtitle": "السداسي {{n}} · {{year}}",
    "print": "طباعة",
    "newSession": "حصة جديدة",
    "view": "العرض",
    "modes": {
      "group": "الفوج",
      "teacher": "الأستاذ",
      "room": "القاعة",
      "overview": "نظرة شاملة"
    },
    "notPlanned": "غير منشور",
    "prevWeek": "الأسبوع السابق",
    "nextWeek": "الأسبوع التالي",
    "today": "اليوم",
    "weekLabel": "الأسبوع {{week}} · {{from}} – {{to}}",
    "days": {
      "mon": "الإثنين",
      "tue": "الثلاثاء",
      "wed": "الأربعاء",
      "thu": "الخميس",
      "fri": "الجمعة",
      "sat": "السبت",
      "sun": "الأحد"
    },
    "kinds": {
      "CM": "محاضرة",
      "TD": "أعمال موجهة",
      "TP": "أعمال تطبيقية"
    },
    "roomKinds": {
      "amphi": "مدرج",
      "salle": "قاعة",
      "labo": "مخبر"
    },
    "emptyTitle": "جدول الأوقات غير منشور",
    "emptyText": "لا توجد حصص مبرمجة هذا الأسبوع.",
    "emptyStaff": "لا توجد حصص هذا الأسبوع. أضف حصة عبر « حصة جديدة ».",
    "conflicts": "التعارضات",
    "noConflict": "لم يتم رصد أي تعارض.",
    "conflictTitle": {
      "room": "القاعة {{resource}} — {{day}} {{time}}",
      "teacher": "{{resource}} — {{day}} {{time}}",
      "group": "الفوج {{resource}} — {{day}} {{time}}"
    },
    "conflictDetail": "{{a}} و{{b}} متداخلان.",
    "conflict": {
      "room": "القاعة {{resource}} مشغولة من قبل {{group}} ({{course}})",
      "teacher": "{{resource}} يدرّس {{group}} ({{course}}) في نفس الوقت",
      "group": "الفوج {{resource}} لديه {{course}} في نفس الوقت"
    },
    "freeRoom": "قاعة شاغرة مقترحة:",
    "reassign": "إعادة التخصيص",
    "reassigned": "تم نقل {{label}} إلى {{room}}. تم إعلام الطلبة والأستاذ.",
    "selected": "الحصة المحددة",
    "selectHint": "اختر حصة من الجدول لعرض التفاصيل.",
    "inConflict": "في تعارض",
    "rollCall": "تسجيل الحضور",
    "openRollCall": "عرض الحضور",
    "slot": {
      "newTitle": "حصة جديدة",
      "editTitle": "تعديل الحصة",
      "group": "الفوج",
      "course": "المادة",
      "teacher": "الأستاذ",
      "room": "القاعة",
      "day": "اليوم",
      "time": "التوقيت",
      "kind": "النوع",
      "conflictsTitle_zero": "لا تعارض",
      "conflictsTitle_one": "تعارض واحد",
      "conflictsTitle_two": "تعارضان",
      "conflictsTitle_few": "{{count}} تعارضات",
      "conflictsTitle_many": "{{count}} تعارضًا",
      "conflictsTitle_other": "{{count}} تعارض",
      "saveAnyway": "حفظ رغم ذلك",
      "created": "تمت إضافة الحصة إلى جدول الأوقات.",
      "updated": "تم تعديل الحصة وتحديث الحصص القادمة.",
      "deleted": "تم حذف الحصة.",
      "deleteTitle": "حذف هذه الحصة المتكررة؟",
      "deleteText": "تُحذف كل حصص هذه الخانة غير المسجلة (بما فيها السابقة) من قائمة الحضور. تبقى التسجيلات المنجزة في السجل.",
      "duplicate": "نسخ",
      "duplicateTitle": "نسخ الحصة",
      "customTime": "توقيت حر…",
      "start": "البداية",
      "end": "النهاية",
      "timeError": "يجب أن تكون النهاية بعد البداية.",
      "window": "تُدرَّس من {{from}} إلى {{to}} (خطة الدراسة).",
      "blockedTitle": "الأستاذ غير متاح",
      "blocked": "الأستاذ يدرّس {{group}} ({{course}}) في هذا الوقت. الحصة المشتركة ممكنة فقط بين أفواج المستوى نفسه.",
      "jointSaved": "تم حفظ حصة مشتركة مع {{groups}}: درس واحد وتسجيل حضور لكل فوج."
    },
    "errors": {
      "generic": "تعذّر الحفظ. أعد المحاولة.",
      "reference": "عنصر محدد لم يعد موجودًا. أعد تحميل الصفحة.",
      "plan": "صادق على خطة الدراسة قبل برمجة جدول الأوقات.",
      "time": "توقيت غير صالح (HH:MM).",
      "endBeforeStart": "يجب أن تكون النهاية بعد البداية."
    },
    "legend": "دليل الألوان:",
    "absent": "غائب",
    "level": "المستوى",
    "allLevels": "كل المستويات",
    "prevDay": "اليوم السابق",
    "nextDay": "اليوم التالي",
    "overviewTitle": "كل الأفواج — {{date}}",
    "jointWith": "حصة مشتركة مع {{groups}}",
    "history": "سجل الأساتذة",
    "historySessions_zero": "لا حصة",
    "historySessions_one": "حصة واحدة",
    "historySessions_two": "حصتان",
    "historySessions_few": "{{count}} حصص",
    "historySessions_many": "{{count}} حصة",
    "historySessions_other": "{{count}} حصة",
    "absence": {
      "badge": "الأستاذ غائب",
      "mark": "الأستاذ غائب",
      "clear": "إلغاء الغياب",
      "marked": "تم تسجيل غياب الأستاذ: تم إعلام الفوج وأُغلق التسجيل.",
      "cleared": "أُلغي الغياب: يمكن تسجيل الحضور من جديد.",
      "rollCallDone": "تم تسجيل حضور هذه الحصة مسبقًا."
    },
    "tags": {
      "title": "البطاقات",
      "hint": "اسحب مادة إلى خانة فارغة، أو أستاذًا أو قاعة إلى حصة.",
      "courses": "المواد",
      "teachers": "الأساتذة",
      "rooms": "القاعات",
      "search": "تصفية البطاقات",
      "pickLevel": "اختر مستوى لعرض مواده.",
      "noCourse": "لا توجد مادة تُدرَّس في هذا السداسي.",
      "otherLevel": "هذه المادة لا تُدرَّس في {{group}}.",
      "sameRow": "تُنقل الحصة على سطر فوجها."
    }
  },
  "announcements": {
    "title": "الإعلانات",
    "subtitle": "تُنشر في تطبيق الطالب حسب الفئة المستهدفة.",
    "new": "إعلان جديد",
    "publish": "نشر",
    "published": "تم نشر الإعلان.",
    "failed": "تعذّر النشر. أعد المحاولة.",
    "deleted": "تم حذف الإعلان.",
    "delete": "حذف « {{title}} »",
    "deleteTitle": "حذف هذا الإعلان؟",
    "emptyTitle": "لا توجد إعلانات",
    "emptyText": "تظهر الإعلانات المنشورة هنا وفي تطبيق الطالب.",
    "fields": {
      "title": "العنوان",
      "body": "الرسالة",
      "kind": "النوع",
      "audience": "الفئة المستهدفة"
    },
    "kinds": {
      "info": "معلومة",
      "event": "حدث",
      "warning": "هام",
      "room": "قاعة"
    },
    "audience": {
      "all": "كل الطلبة",
      "program": "الشعبة",
      "level": "المستوى",
      "group": "الفوج"
    }
  },
  "notifications": {
    "weekdays": {
      "1": "الإثنين",
      "2": "الثلاثاء",
      "3": "الأربعاء",
      "4": "الخميس",
      "5": "الجمعة",
      "6": "السبت",
      "7": "الأحد"
    },
    "sessions": {
      "principale": "الرئيسية",
      "rattrapage": "الاستدراكية"
    },
    "absence": {
      "recorded": {
        "title": "تم تسجيل غياب — {{course}}",
        "body": "لديك {{hours}} ساعة لتقديم مبرر."
      },
      "alert": {
        "title": "الغيابات — {{course}}",
        "body": "نسبة الغيابات غير المبررة: {{pct}}."
      }
    },
    "timetable": {
      "room": {
        "title": "تغيير القاعة — {{course}}",
        "body": "يوم {{day}} على الساعة {{time}}، تُقام الحصة في {{room}}."
      },
      "conflict": {
        "title": "تعارض في القاعة",
        "body": "{{room}} · {{day}} {{time}} · {{groups}}"
      },
      "teacherAbsent": {
        "title": "حصة ملغاة — {{course}}",
        "body": "الأستاذ غائب يوم {{at}}."
      }
    },
    "justification": {
      "approved": {
        "title": "تم قبول المبرر",
        "body": "تم تبرير غياباتك."
      },
      "rejected": {
        "title": "تم رفض المبرر",
        "body": "يرجى الاتصال بإدارة الدراسة."
      }
    },
    "request": {
      "done": {
        "title": "{{kind}}: تمت معالجة الطلب",
        "body": "الوثيقة متاحة لدى إدارة الدراسة أو في وثائقك."
      },
      "rejected": {
        "title": "{{kind}}: تم رفض الطلب",
        "body": "يرجى الاتصال بإدارة الدراسة لمزيد من التفاصيل."
      }
    },
    "deliberation": {
      "pvToValidate": {
        "title": "محضر مداولات للمصادقة",
        "body": "{{level}} · السداسي {{semester}} · الدورة {{session}}"
      }
    },
    "title": "لك",
    "empty": "لا توجد إشعارات.",
    "gradeReview": {
      "requested": {
        "title": "مطلب مراجعة عدد",
        "body": "{{student}} · {{course}}"
      },
      "answered": {
        "title": "الردّ على مطلب المراجعة",
        "body": "{{course}}: {{outcome}}"
      }
    },
    "internship": {
      "answers": {
        "accepted": "مقبول",
        "refused": "مرفوض",
        "assigned": "تمّ تعيينك"
      },
      "decision": {
        "title": "موضوع التربص: {{status}}",
        "body": "{{title}}"
      },
      "supervisionRequested": {
        "title": "مطلب تأطير",
        "body": "{{title}}"
      },
      "supervisionAnswered": {
        "title": "تأطير التربص",
        "body": "{{title}}: {{answer}}"
      },
      "defensePublished": {
        "title": "نُشر تاريخ المناقشة",
        "body": "تنتظم مناقشتك يوم {{at}}."
      }
    }
  },
  "account": {
    "menu": "حسابي",
    "title": "حسابي",
    "passwordTitle": "كلمة المرور",
    "passwordHint": "{{min}} أحرف على الأقل. سيتم إغلاق جلساتك الأخرى (الأجهزة الأخرى).",
    "current": "كلمة المرور الحالية",
    "new": "كلمة المرور الجديدة",
    "confirm": "تأكيد كلمة المرور الجديدة",
    "submit": "تغيير كلمة المرور",
    "passwordChanged": "تم تغيير كلمة المرور. تم إغلاق جلساتك الأخرى.",
    "errors": {
      "wrongPassword": "كلمة المرور الحالية غير صحيحة.",
      "generic": "تعذّر التغيير. أعد المحاولة بعد لحظات."
    }
  },
  "audit": {
    "actions": {
      "absence_justify": "تبرير غيابات",
      "absence_justify_reject": "رفض تبرير",
      "absence_notify": "إرسال تنبيه غيابات",
      "announcement_create": "نشر إعلان",
      "announcement_delete": "حذف إعلان",
      "application_convert": "تحويل ترشّح إلى ترسيم",
      "application_piece_upload": "إيداع وثيقة ترشّح",
      "application_status": "تغيير حالة ترشّح",
      "application_submit": "إيداع ترشّح",
      "attendance_update": "تعديل المناداة",
      "auth_password_change": "تغيير كلمة المرور",
      "auth_password_reset": "إعادة تعيين كلمة المرور",
      "auth_refresh_reuse_detected": "غلق جلسة مشبوهة",
      "curriculum_delete": "حذف برنامج تكوين",
      "curriculum_new_version": "نسخة جديدة من البرنامج",
      "curriculum_publish": "نشر برنامج تكوين",
      "document_issue": "إصدار وثيقة",
      "document_revoke": "إلغاء وثيقة",
      "document_send": "إرسال وثيقة بالبريد",
      "document_request_done": "معالجة طلب وثيقة",
      "document_request_rejected": "رفض طلب وثيقة",
      "enrollment_create": "ترسيم",
      "enrollment_group_change": "تغيير الفوج",
      "enrollment_update": "تعديل ترسيم",
      "fee_schedule_apply": "تطبيق سلّم المعاليم",
      "fee_schedule_save": "تعديل سلّم المعاليم",
      "grade_correction_request": "طلب إصلاح عدد",
      "grade_update": "تعديل عدد بعد الحفظ",
      "grades_import": "توريد أعداد (إكسال)",
      "grades_lock": "إحالة ورقة الأعداد",
      "grades_unlock": "إعادة فتح ورقة الأعداد",
      "jury_decision": "تعديل قرار اللجنة",
      "jury_pv": "توليد المحضر",
      "jury_rattrapage_sheets": "إنشاء أوراق التدارك",
      "payment_cancel": "إلغاء دفعة",
      "payment_clear": "استخلاص دفعة",
      "payment_create": "تسجيل دفعة",
      "payment_reject": "رفض صك",
      "permissions_update": "تعديل الصلاحيات",
      "platform_tenant_create": "إنشاء المؤسسة",
      "program_create": "إنشاء شعبة",
      "room_create": "إنشاء قاعة",
      "room_update": "تعديل قاعة",
      "student_create": "إنشاء ملف طالب",
      "student_update": "تعديل ملف طالب",
      "tenant_branding": "تعديل الهوية البصرية",
      "tenant_logo": "تعديل الشعار",
      "tenant_update": "تعديل إعدادات المؤسسة",
      "timetable_slot_delete": "حذف حصّة",
      "timetable_slot_room": "تغيير قاعة حصّة",
      "year_activate": "فتح سنة جامعية",
      "year_archive": "أرشفة سنة جامعية",
      "year_create": "إنشاء سنة جامعية",
      "year_delete": "حذف سنة جامعية",
      "year_update": "تعديل سنة جامعية",
      "platform_tenant_suspend": "تعليق المؤسسة",
      "platform_tenant_activate": "إعادة تفعيل المؤسسة",
      "platform_tenant_reinvite": "إعادة إرسال الدعوة إلى المسؤول",
      "platform_admin_reset": "إعادة تعيين كلمة مرور المشرف العام (الخادم)",
      "platform_admin_create": "إنشاء المشرف العام (الخادم)",
      "teacher_create": "إنشاء بطاقة مدرّس",
      "teacher_update": "تعديل بطاقة مدرّس",
      "teacher_export": "تصدير قائمة المدرّسين (إكسال)",
      "study_plan_period": "تعديل فترة التدريس",
      "study_plan_validate": "المصادقة على خطة الدراسة"
    },
    "entities": {
      "student": "طالب",
      "grade_sheet": "ورقة أعداد",
      "jury": "لجنة المداولات",
      "application": "ترشّح",
      "user": "حساب",
      "settings": "الإعدادات",
      "academic_year": "سنة جامعية",
      "curriculum": "برنامج التكوين",
      "timetable_slot": "جدول الأوقات",
      "announcement": "إعلان",
      "tenant": "المؤسسة",
      "attendance": "الحضور",
      "class_session": "حصّة",
      "fee_schedule": "سلّم المعاليم",
      "program": "الشعبة",
      "room": "قاعة",
      "teacher": "مدرّس",
      "study_plan": "خطة الدراسة"
    },
    "title": "سجلّ التدقيق",
    "subtitle": "العمليات الحسّاسة: من، ماذا، متى. التفاصيل في كل ملف.",
    "columns": {
      "at": "التاريخ",
      "actor": "بواسطة",
      "action": "العملية",
      "record": "يخصّ"
    },
    "search": "شخص، طالب، رقم تسجيل…",
    "since": "منذ",
    "empty": "لا توجد عمليات مسجّلة",
    "emptyText": "غيّر عوامل التصفية أو عد لاحقًا."
  },
  "teachers": {
    "title": "الأساتذة",
    "subtitle": "البطاقة والحساب البنكي والانتماء الاجتماعي. تصدير إكسل يُبقي الأساتذة النشطين الذين لديهم مادة هذه السنة فقط.",
    "new": "أستاذ جديد",
    "edit": "تعديل الأستاذ",
    "save": "حفظ",
    "export": "تصدير إكسل",
    "empty": "لا يوجد أساتذة",
    "created": "تم إنشاء الأستاذ. يختار كلمة السر عبر « نسيت كلمة السر ».",
    "updated": "تم حفظ بطاقة الأستاذ.",
    "noSubject": "لا توجد مادة",
    "status": {
      "active": "نشط",
      "disabled": "غير نشط",
      "invited": "مدعو"
    },
    "affiliation": {
      "cnss": "CNSS",
      "cnrps": "CNRPS",
      "none": "بدون انتماء"
    },
    "fields": {
      "firstName": "الاسم",
      "lastName": "اللقب",
      "email": "البريد الإلكتروني",
      "cin": "بطاقة التعريف",
      "rib": "الحساب البنكي",
      "affiliation": "الانتماء الاجتماعي",
      "affiliationNumber": "رقم الانتماء",
      "fiscalId": "المعرف الجبائي",
      "active": "أستاذ نشط"
    },
    "hints": {
      "cin": "8 أرقام.",
      "rib": "20 رقمًا، دون حروف."
    },
    "errors": {
      "required": "حقل إلزامي.",
      "email": "يرجى إدخال بريد إلكتروني صالح.",
      "cin": "بطاقة التعريف يجب أن تحتوي على 8 أرقام.",
      "rib": "الحساب البنكي يجب أن يحتوي على 20 رقمًا بالضبط.",
      "duplicateCin": "رقم بطاقة التعريف هذا موجود بالفعل في النظام.",
      "duplicateEmail": "هذا البريد مستعمل بالفعل.",
      "affiliationNumber": "أدخل رقم الانتماء.",
      "affiliationNone": "لا رقم بدون انتماء.",
      "generic": "تعذّر الحفظ. راجع البطاقة."
    }
  },
  "studyPlan": {
    "title": "خطة الدراسة",
    "open": "خطة الدراسة",
    "subtitle": "سنة {{year}} — صادق على الخطة قبل جدول الأوقات.",
    "next": "متابعة",
    "createProgram": "شعبة جديدة",
    "programCreated": "تم إنشاء الشعبة.",
    "addClass": "قسم جديد",
    "groupCreated": "تم إنشاء القسم.",
    "noClass": "لا يوجد قسم هذه السنة.",
    "addBasket": "سلة جديدة",
    "addSubject": "مادة جديدة",
    "emptyBasket": "سلة فارغة.",
    "saved": "تم الحفظ.",
    "validated": "تمت المصادقة على خطة الدراسة.",
    "ready": "الخطة متّسقة. يمكن المصادقة عليها.",
    "published": "هذا المسار منشور. السلال والمواد تُعدَّل في نسخة جديدة.",
    "openBuilder": "فتح المسار",
    "filiereHint": "أنشئ الشعبة ثم اربط بها الأقسام.",
    "classesHint": "كل مستوى في الشعبة يحتاج قسمًا واحدًا على الأقل للسنة المختارة.",
    "paniersHint": "السلال (الوحدات) تجمع مواد السداسي. أقسام نفس المستوى تشترك فيها.",
    "subjectsHint": "لكل مادة ضارب وحجم ساعي.",
    "datesHint": "حدّد تاريخ بداية ونهاية لكل مادة داخل السنة الجامعية.",
    "validationHint": "راجع الشعبة والأقسام والسلال والضوارب والأحجام والتواريخ قبل المصادقة.",
    "validate": "المصادقة على خطة الدراسة",
    "semester": "السداسي {{n}}",
    "subjectMeta": "الضارب {{weight}} · {{hours}} س",
    "status": {
      "missing": "غير مُعدّ",
      "draft": "مسودّة",
      "validated": "مُصادَق"
    },
    "steps": {
      "filiere": "الشعبة",
      "classes": "الأقسام",
      "paniers": "السلال",
      "matieres": "المواد",
      "dates": "التواريخ",
      "validation": "المصادقة"
    },
    "fields": {
      "program": "الشعبة",
      "semester": "السداسي",
      "code": "رمز السلة",
      "name": "الاسم",
      "basket": "السلة",
      "weight": "الضارب",
      "hours": "الحجم الساعي",
      "cm": "محاضرة",
      "td": "تمارين",
      "tp": "تطبيق",
      "startsOn": "البداية",
      "endsOn": "النهاية"
    },
    "issues": {
      "no_curriculum": "أنشئ أولًا مسار الشعبة.",
      "credits": "السداسي {{semester}} مجموع أرصيده {{credits}} بدل {{target}}.",
      "empty_semester": "السداسي {{semester}} بلا سلة.",
      "empty_unit": "السلة {{unit}} (السداسي {{semester}}) فارغة.",
      "no_class": "لا قسم لـ {{level}} هذه السنة.",
      "weight": "{{course}} بلا ضارب.",
      "hours": "{{course}} بلا حجم ساعي.",
      "dates": "{{course}} بلا تاريخ بداية ونهاية.",
      "dates_order": "نهاية {{course}} يجب أن تكون بعد البداية.",
      "dates_outside": "تواريخ {{course}} خارج السنة الجامعية."
    },
    "errors": {
      "generic": "تعذّرت العملية. أعد المحاولة.",
      "invalid": "الخطة ليست متّسقة بعد.",
      "date": "تاريخ غير صالح.",
      "order": "النهاية يجب أن تكون بعد البداية."
    }
  },
  "calendar": {
    "title": "الرزنامة الجامعية",
    "subtitle": "العودة الجامعية، العطل، الامتحانات، المداولات والمناقشات · {{year}}",
    "new": "حدث جديد",
    "editTitle": "تعديل الحدث",
    "show": "الأحداث المعروضة",
    "upcoming": "القادمة",
    "wholeYear": "كامل السنة",
    "now": "جارٍ",
    "created": "أُضيف الحدث إلى الرزنامة.",
    "updated": "عُدّل الحدث.",
    "deleted": "حُذف الحدث.",
    "deleteTitle": "حذف هذا الحدث؟",
    "edit": "تعديل «{{title}}»",
    "delete": "حذف «{{title}}»",
    "emptyTitle": "رزنامة السنة فارغة",
    "noUpcomingTitle": "لا تواريخ قادمة",
    "emptyText": "ستظهر تواريخ السنة هنا بمجرّد أن تنشرها الإدارة.",
    "emptyTextEditor": "أضف العودة الجامعية والعطل وفترات الامتحانات والمداولات: يراها الطلبة والأساتذة في فضائهم.",
    "fields": {
      "title": "العنوان",
      "kind": "النوع",
      "audience": "مرئي لـ",
      "startsOn": "من",
      "endsOn": "إلى (اختياري)",
      "description": "تفاصيل (اختياري)"
    },
    "kinds": {
      "start": "العودة الجامعية",
      "holiday": "عطلة / يوم عطلة",
      "exams": "امتحانات",
      "deliberation": "مداولة",
      "defense": "مناقشات",
      "deadline": "آخر أجل",
      "event": "حدث"
    },
    "audience": {
      "all": "الجميع",
      "students": "الطلبة",
      "staff": "الإداريون والأساتذة"
    },
    "errors": {
      "title": "أدخل عنوانًا.",
      "date": "تاريخ غير صالح.",
      "range": "يجب أن يأتي تاريخ النهاية بعد تاريخ البداية."
    }
  },
  "gradeReviews": {
    "title": "مطالب مراجعة الأعداد",
    "subtitle": "أعداد منشورة يطلب الطلبة مراجعتها",
    "backToSheets": "بطاقات الأعداد",
    "filter": "المطالب المعروضة",
    "answered": "تمت معالجتها",
    "allSheets": "كل البطاقات",
    "emptyPendingTitle": "لا مطالب في الانتظار",
    "emptyTitle": "لا مطالب",
    "emptyText": "يمكن للطلبة طلب مراجعة عدد خلال بضعة أيام بعد نشر النتائج.",
    "about": "{{course}} · {{group}} · S{{semester}} · دورة {{session}}",
    "openSheet": "فتح البطاقة",
    "answer": "الردّ",
    "answerTitle": "الردّ على {{name}}",
    "outcome": "نتيجة المراجعة",
    "correctHint": "صحّح العدد أيضًا: في الجدول إذا كانت البطاقة قيد الإدخال، أو عبر مطلب تصحيح إذا كانت مُحالة.",
    "response": "الردّ على الطالب",
    "send": "إرسال الردّ",
    "sent": "أُرسل الردّ إلى الطالب.",
    "pendingCount_zero": "لا مطالب في الانتظار",
    "pendingCount_one": "مطلب واحد في الانتظار",
    "pendingCount_two": "مطلبان في الانتظار",
    "pendingCount_few": "{{count}} مطالب في الانتظار",
    "pendingCount_many": "{{count}} مطلبًا في الانتظار",
    "pendingCount_other": "{{count}} مطلب في الانتظار",
    "rowChip": "مراجعة مطلوبة",
    "rowHint": "طلب الطالب مراجعة هذا العدد",
    "bannerTitle_zero": "لا مطالب مراجعة",
    "bannerTitle_one": "مطلب مراجعة واحد في الانتظار",
    "bannerTitle_two": "مطلبا مراجعة في الانتظار",
    "bannerTitle_few": "{{count}} مطالب مراجعة في الانتظار",
    "bannerTitle_many": "{{count}} مطلب مراجعة في الانتظار",
    "bannerTitle_other": "{{count}} مطلب مراجعة في الانتظار",
    "bannerDraft": "راجع الورقة، وصحّح العدد في الجدول عند الحاجة، ثمّ ردّ على الطالب.",
    "bannerLocked": "راجع الورقة؛ إذا تغيّر العدد قدّم مطلب تصحيح، ثمّ ردّ على الطالب.",
    "answerRequests": "عرض المطالب والردّ",
    "status": {
      "pending": "في الانتظار",
      "maintained": "العدد ثابت",
      "corrected": "العدد مصحّح"
    },
    "errors": {
      "message": "اشرح طلبك ببضع كلمات (10 أحرف على الأقل).",
      "response": "اكتب ردًّا."
    },
    "student": {
      "ask": "طلب مراجعة",
      "title": "مطلب مراجعة عدد",
      "intro": "هل تعتقد أنّ عددك في {{course}} خاطئ (خطأ في النقل، ورقة لم تُحتسب…)؟ يراجع الأستاذ ويردّ عليك هنا.",
      "message": "طلبك",
      "placeholder": "مثال: عدد الامتحان لا يطابق ورقتي.",
      "helper": "كن دقيقًا: الامتحان أو الفرض أو الأشغال التطبيقية المعنية.",
      "send": "إرسال الطلب",
      "sent": "أُرسل الطلب. ستتلقّى إشعارًا بالردّ.",
      "window": "يمكنك طلب مراجعة عدد إلى غاية {{date}}.",
      "status": {
        "pending": "المراجعة مطلوبة",
        "maintained": "الردّ: العدد ثابت",
        "corrected": "الردّ: العدد مصحّح"
      },
      "errors": {
        "already_pending": "يوجد مطلب جارٍ لهذا العدد.",
        "window": "انتهى أجل طلب المراجعة.",
        "not_published": "لم تُنشر نتائج هذه الدورة بعد.",
        "disabled": "المؤسسة لا تتلقّى مطالب المراجعة.",
        "failed": "تعذّر إرسال الطلب. أعد المحاولة."
      }
    }
  },
  "internships": {
    "title": "التربصات ومشاريع التخرج",
    "myTitle": "تأطيراتي",
    "subtitle": "المواضيع والتأطير والإيداعات والمناقشات لهذه السنة",
    "new": "تربص جديد",
    "newHint": "التربص الذي تنشئه مصلحة الدراسة يُصادق عليه مباشرة: تُصدر الاتفاقية ويُعيَّن المؤطر.",
    "create": "إنشاء التربص",
    "created": "تمّ إنشاء التربص {{code}}.",
    "editTitle": "تعديل التربص",
    "saved": "تمّ حفظ التربص.",
    "notFound": "التربص غير موجود",
    "pfe": "مشروع تخرج",
    "search": "الموضوع أو المؤسسة أو الطالب أو المعرّف",
    "allTypes": "كل الأصناف",
    "allStatuses": "كل الحالات",
    "roleFilter": "التربصات المعروضة",
    "roles": {
      "supervisor": "أؤطّرها",
      "requests": "مطالب التأطير",
      "jury": "لجاني"
    },
    "emptyTitle": "لا تربصات هذه السنة",
    "emptyText": "يصرّح الطلبة بتربصاتهم من فضائهم، ويمكن لمصلحة الدراسة إنشاؤها أيضًا.",
    "emptyRole": {
      "supervisor": "لا تؤطّر أي تربص",
      "requests": "لا مطالب تأطير",
      "jury": "لا لجان حاليًا"
    },
    "emptyTeacherText": "يمكن للطلبة اقتراحك مؤطرًا، وستتلقّى إشعارًا بذلك.",
    "tabs": {
      "list": "التربصات",
      "sessions": "المناقشات",
      "types": "الأصناف"
    },
    "columns": {
      "code": "المرجع",
      "title": "الموضوع",
      "students": "الطلبة",
      "supervisor": "المؤطر",
      "documents": "الإيداعات",
      "defense": "المناقشة",
      "status": "الحالة"
    },
    "status": {
      "proposed": "مقترح",
      "to_revise": "للمراجعة",
      "approved": "مصادق عليه",
      "refused": "مرفوض"
    },
    "supervision": {
      "none": "لا شيء",
      "pending": "في الانتظار",
      "accepted": "مقبول",
      "refused": "مرفوض"
    },
    "documents": {
      "report": "التقرير",
      "certificate": "شهادة التربص",
      "plagiarism": "تقرير مكافحة الانتحال",
      "logbook": "دفتر التربص",
      "company_evaluation": "تقييم المؤسسة"
    },
    "sections": {
      "subject": "الموضوع",
      "company": "مؤسسة الاستقبال",
      "students": "الطلبة",
      "supervision": "التأطير الجامعي",
      "deposits": "الإيداعات",
      "defense": "المناقشة"
    },
    "fields": {
      "type": "الصنف",
      "title": "عنوان الموضوع",
      "description": "الأهداف والعمل المطلوب",
      "startsOn": "البداية",
      "endsOn": "النهاية",
      "period": "الفترة",
      "companyName": "المؤسسة أو الهيكل",
      "companyCity": "المدينة",
      "companyAddress": "العنوان",
      "companySupervisorName": "المؤطر المهني",
      "companySupervisorEmail": "البريد الإلكتروني للمؤطر",
      "companySupervisorPhone": "هاتف المؤطر",
      "contact": "الاتصال",
      "supervisor": "المؤطر الجامعي",
      "supervisorHint": "يتلقّى الأستاذ مطلب تأطير لقبوله.",
      "students_zero": "الطلبة",
      "students_one": "طالب",
      "students_two": "طالبان",
      "students_few": "الطلبة (حتى {{count}})",
      "students_many": "الطلبة (حتى {{count}})",
      "students_other": "الطلبة (حتى {{count}})",
      "studentsMax_zero": "لا طلبة",
      "studentsMax_one": "طالب واحد لهذا الصنف",
      "studentsMax_two": "طالبان على الأكثر",
      "studentsMax_few": "{{count}} طلبة على الأكثر",
      "studentsMax_many": "{{count}} طالبًا على الأكثر",
      "studentsMax_other": "{{count}} طالب على الأكثر",
      "studentsHint": "اكتب حرفين على الأقل من الاسم أو المعرّف",
      "noStudent": "لم يُعثر على أي طالب"
    },
    "noSupervisor": "لا مؤطر بعد",
    "noDescription": "لا وصف.",
    "assignSupervisor": "تعيين المؤطر",
    "changeSupervisor": "تغيير المؤطر",
    "supervisorSaved": "تمّ تعيين المؤطر.",
    "supervisionRequest": "يقترح عليك طالب تأطير هذا التربص.",
    "acceptSupervision": "قبول التأطير",
    "refuseSupervision": "رفض",
    "supervisionAccepted": "تمّ قبول التأطير وإعلام الطالب.",
    "supervisionRefused": "تمّ رفض التأطير وإعلام الطالب.",
    "decide": "قرار بخصوص الموضوع",
    "decision": "القرار",
    "confirmDecision": "حفظ القرار",
    "approveHint": "تُصدر اتفاقية التربص عند المصادقة، ويجدها كل طالب في وثائقه.",
    "reason": "تعليق (اختياري)",
    "reasonRequired": "السبب (يُبلَّغ للطالب)",
    "decided": {
      "approved": "تمّت المصادقة على الموضوع وإصدار الاتفاقية.",
      "to_revise": "أُعيد الموضوع إلى الطالب للمراجعة.",
      "refused": "رُفض الموضوع."
    },
    "issueConvention": "إصدار الاتفاقية",
    "conventionIssued": "تمّ إصدار الاتفاقية.",
    "depositAfterApproval": "تُفتح الإيداعات بعد المصادقة على الموضوع.",
    "depositClosed": "الإيداعات مغلقة (خارج فترة الإيداع).",
    "notDeposited": "لم يُودع بعد",
    "deposit": "إيداع",
    "replace": "استبدال",
    "view": "عرض",
    "deposited": "تمّ إيداع الوثيقة.",
    "noDefense": "لم تُبرمج المناقشة بعد.",
    "grade": "العدد",
    "gradeSaved": "تمّ حفظ العدد.",
    "jury": {
      "president": "رئيس اللجنة",
      "reviewer": "المقرّر",
      "supervisor": "المؤطر",
      "guest": "مدعوّ",
      "line": "الرئيس: {{president}} · المقرّر: {{reviewer}} · المؤطر: {{supervisor}}",
      "supervisorHint": "يحضر المؤطر الجامعي بحكم صفته، ولا يمكن أن يكون رئيسًا أو مقرّرًا."
    },
    "clashes": {
      "room": "القاعة مشغولة بـ«{{title}}» ({{time}})",
      "president": "الرئيس عضو في «{{title}}» ({{time}})",
      "reviewer": "المقرّر عضو في «{{title}}» ({{time}})",
      "supervisor": "المؤطر مشغول بـ«{{title}}» ({{time}})",
      "student": "أحد الطلبة يناقش «{{title}}» ({{time}})"
    },
    "sessions": {
      "intro": "تحدّد الدورة فترة المناقشات، وقبلها فترة إيداع التقارير.",
      "new": "دورة جديدة",
      "editTitle": "تعديل الدورة",
      "created": "تمّ إنشاء الدورة.",
      "updated": "تمّ تعديل الدورة.",
      "allTypes": "كل الأصناف",
      "depositUntil": "الإيداع إلى غاية {{date}}",
      "counts": "{{scheduled}} مبرمجة · {{published}} منشورة",
      "emptyTitle": "لا دورات مناقشة",
      "emptyText": "أنشئ دورة لبرمجة المناقشات وفتح الإيداعات.",
      "fields": {
        "title": "العنوان",
        "startsOn": "المناقشات من",
        "endsOn": "إلى",
        "depositFrom": "الإيداع ابتداءً من",
        "depositUntil": "الإيداع إلى غاية",
        "date": "التاريخ",
        "time": "الساعة",
        "room": "القاعة"
      },
      "depositHint": "دون فترة إيداع، يودع الطلبة بمجرّد المصادقة على مواضيعهم.",
      "publish": "نشر المناقشات",
      "unpublish": "سحب النشر",
      "publishedToast": "نُشرت المناقشات وأُعلم الطلبة.",
      "unpublishedToast": "تمّ سحب النشر.",
      "notPublished": "لم تُنشر المناقشات بعد: لا يرى الطلبة التاريخ ولا اللجنة.",
      "published": "منشورة",
      "draft": "غير منشورة",
      "scheduled_zero": "لا مناقشات مبرمجة",
      "scheduled_one": "مناقشة واحدة مبرمجة",
      "scheduled_two": "مناقشتان مبرمجتان",
      "scheduled_few": "{{count}} مناقشات مبرمجة",
      "scheduled_many": "{{count}} مناقشة مبرمجة",
      "scheduled_other": "{{count}} مناقشة مبرمجة",
      "toSchedule_zero": "لا تربصات للبرمجة",
      "toSchedule_one": "تربص واحد للبرمجة",
      "toSchedule_two": "تربصان للبرمجة",
      "toSchedule_few": "{{count}} تربصات للبرمجة",
      "toSchedule_many": "{{count}} تربصًا للبرمجة",
      "toSchedule_other": "{{count}} تربص للبرمجة",
      "noneScheduled": "لا مناقشات مبرمجة",
      "noneScheduledText": "برمج التربصات المصادق عليها أدناه.",
      "noCandidate": "لا تربصات مصادق عليها في انتظار المناقشة لهذه الدورة.",
      "ready": "الملف مكتمل",
      "missing": "ينقص: {{list}}",
      "schedule": "برمجة",
      "reschedule": "تعديل المناقشة",
      "scheduledToast": "تمّت برمجة المناقشة.",
      "warningTitle": "للتحقّق قبل البرمجة",
      "force": "البرمجة رغم ذلك",
      "editDefense": "تعديل مناقشة «{{title}}»",
      "deleteDefense": "حذف مناقشة «{{title}}»",
      "deleteDefenseTitle": "حذف هذه المناقشة؟"
    },
    "types": {
      "intro": "يحدّد كل صنف (تربص صيفي، مشروع تخرج…) المستويات المعنية وحجم الفرق والوثائق المطلوبة والمناقشة.",
      "new": "صنف جديد",
      "editTitle": "تعديل الصنف",
      "created": "تمّ إنشاء الصنف.",
      "updated": "تمّ تعديل الصنف.",
      "deleted": "تمّ حذف الصنف.",
      "deleteTitle": "حذف هذا الصنف؟",
      "edit": "تعديل «{{name}}»",
      "delete": "حذف «{{name}}»",
      "duplicate": "يوجد صنف بهذا الاسم.",
      "usedHint_zero": "غير مستعمل",
      "usedHint_one": "يستعمله تربص واحد: عطّله بدل حذفه",
      "usedHint_two": "يستعمله تربصان: عطّله بدل حذفه",
      "usedHint_few": "تستعمله {{count}} تربصات: عطّله بدل حذفه",
      "usedHint_many": "يستعمله {{count}} تربصًا: عطّله بدل حذفه",
      "usedHint_other": "يستعمله {{count}} تربص: عطّله بدل حذفه",
      "inactive": "معطّل",
      "allLevels": "كل المستويات",
      "weeks_zero": "0 أسبوع",
      "weeks_one": "أسبوع واحد",
      "weeks_two": "أسبوعان",
      "weeks_few": "{{count}} أسابيع",
      "weeks_many": "{{count}} أسبوعًا",
      "weeks_other": "{{count}} أسبوع",
      "team_zero": "فردي",
      "team_one": "فردي",
      "team_two": "ثنائي",
      "team_few": "فريق من {{count}} على الأكثر",
      "team_many": "فريق من {{count}} على الأكثر",
      "team_other": "فريق من {{count}} على الأكثر",
      "defense_zero": "مناقشة",
      "defense_one": "مناقشة لمدة دقيقة",
      "defense_two": "مناقشة لمدة دقيقتين",
      "defense_few": "مناقشة لمدة {{count}} دقائق",
      "defense_many": "مناقشة لمدة {{count}} دقيقة",
      "defense_other": "مناقشة لمدة {{count}} دقيقة",
      "noDefense": "دون مناقشة",
      "declarable": "يصرّح به الطالب",
      "byOffice": "تنشئه مصلحة الدراسة",
      "emptyTitle": "لا أصناف تربص",
      "emptyText": "أنشئ صنفًا واحدًا على الأقل (مثلًا «تربص صيفي» و«مشروع تخرج») حتى يمكن التصريح بالتربصات.",
      "fields": {
        "name": "الاسم",
        "levels": "المستويات المعنية",
        "levelsHint": "دون اختيار: كل المستويات.",
        "weeks": "المدة (أسابيع)",
        "team": "عدد الطلبة لكل تربص",
        "minutes": "مدة المناقشة (دقيقة)",
        "isPfe": "مشروع ختم الدروس",
        "declarable": "يصرّح الطلبة بأنفسهم بتربصاتهم",
        "companySupervisor": "المؤطر المهني إجباري (الاسم والبريد)",
        "hasDefense": "مناقشة أمام لجنة",
        "active": "نشط (مقترح للتربصات الجديدة)",
        "required": "الوثائق الواجب إيداعها قبل المناقشة"
      }
    },
    "errors": {
      "invalid": "تحقّق من حقول الاستمارة.",
      "type": "اختر صنف التربص.",
      "title": "أدخل عنوانًا (5 أحرف على الأقل).",
      "name": "أدخل اسمًا.",
      "company": "أدخل مؤسسة الاستقبال.",
      "date": "تاريخ غير صالح.",
      "range": "يجب أن يأتي تاريخ النهاية بعد تاريخ البداية.",
      "phone": "هاتف غير صالح.",
      "email": "بريد إلكتروني غير صالح.",
      "reason": "اذكر السبب.",
      "students": "اختر طالبًا واحدًا على الأقل.",
      "team_size": "عدد الطلبة كبير لهذا الصنف.",
      "company_supervisor": "اسم المؤطر المهني وبريده إجباريان لهذا الصنف.",
      "already": "يوجد تربص من هذا الصنف لهذه السنة.",
      "level": "هذا الصنف لا يخصّ هذا المستوى.",
      "not_enrolled": "الطالب غير مسجّل هذه السنة.",
      "not_teacher": "اختر أستاذًا من المؤسسة.",
      "not_declarable": "هذا التربص تسجّله مصلحة الدراسة.",
      "inactive": "لم يعد هذا الصنف مقترحًا.",
      "decided": "تمّت المصادقة على الموضوع: اتصل بمصلحة الدراسة لتعديله.",
      "graded": "التربص مُقيَّم.",
      "supervision": "يوجد مطلب تأطير جارٍ.",
      "not_approved": "لم تتمّ المصادقة على الموضوع بعد.",
      "closed": "فترة الإيداع مغلقة.",
      "too_large": "الملف كبير جدًا (10 ميغابايت على الأكثر).",
      "type_file": "صيغة غير مقبولة: PDF أو JPEG أو PNG.",
      "empty": "لم يُرسل أي ملف.",
      "upload": "فشل الإيداع. أعد المحاولة.",
      "jury": "يجب أن يكون الرئيس والمقرّر والمؤطر ثلاثة أشخاص مختلفين.",
      "outside_session": "التاريخ خارج فترة الدورة.",
      "session": "هذا التربص لا يندرج في هذه الدورة.",
      "already_scheduled": "لهذا التربص مناقشة مبرمجة.",
      "president": "اختر رئيس اللجنة.",
      "reviewer": "اختر المقرّر."
    }
  }
}
